import React, { useState, useEffect } from 'react';

import {
    Home,
    TrendingUp,
    Users,
    FileText,
    Wrench,
    File,
    MessageCircle,
    User,
    Lock,
    CheckCircle,
    ExternalLink,
    Download,
    Plus,
    Settings,
    Star,
    Crown,
    Zap,
    Menu,
    X,
    DollarSign,
    Award,
    Calendar,
    Eye,
    Copy,
    Construction,
    ChevronRight,
    ChevronDown,
    ChevronLeft,
    ArrowUpCircle,
    Gift,
    Clock,
    TrendingDown,
    BarChart3,
    RefreshCw,
    AlertCircle,
    Loader2,
    Search,
    CreditCard,
    Edit3,
    Share2,
    QrCode,
    Trash2,
    EyeOff,
    Globe,
    Image as ImageIcon
} from 'lucide-react';

const API_BASE = 'https://backhands.b7774c.ru/api/v1';
// === КОМПОНЕНТ СНЕЖИНОК ===
const Snowfall = () => {
    const [snowflakes, setSnowflakes] = React.useState([]);

    React.useEffect(() => {
        const flakes = Array.from({ length: 50 }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            animationDuration: 5 + Math.random() * 10,
            animationDelay: Math.random() * 5,
            size: 10 + Math.random() * 20,
            opacity: 0.4 + Math.random() * 0.6
        }));
        setSnowflakes(flakes);
    }, []);

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 1000,
            overflow: 'hidden'
        }}>
            {snowflakes.map(flake => (
                <div
                    key={flake.id}
                    className="snowflake-item"
                    style={{
                        position: 'absolute',
                        left: `${flake.left}%`,
                        top: '-50px',
                        color: 'white',
                        fontSize: `${flake.size}px`,
                        opacity: flake.opacity,
                        textShadow: '0 0 5px rgba(255,255,255,0.8)',
                        animation: `snowfallAnim ${flake.animationDuration}s linear ${flake.animationDelay}s infinite`
                    }}
                >
                    ❄
                </div>
            ))}
        </div>
    );
};
// === КОМПОНЕНТ ГИРЛЯНДЫ ===
const ChristmasLights = () => {
    const colors = ['#ff0000', '#00ff00', '#ffff00', '#00bfff', '#ff69b4', '#ffa500'];

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-around',
            padding: '0 10px',
            height: '35px',
            background: 'rgba(0,0,0,0.3)'
        }}>
            {Array.from({ length: 20 }, (_, i) => (
                <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ width: '2px', height: '8px', background: '#2a2a2a' }}></div>
                    <div
                        className="light-bulb-item"
                        style={{
                            width: '10px',
                            height: '14px',
                            borderRadius: '50%',
                            background: colors[i % 6],
                            boxShadow: `0 0 10px ${colors[i % 6]}, 0 0 20px ${colors[i % 6]}`,
                            animation: `twinkleAnim 1s ease-in-out ${i * 0.15}s infinite alternate`
                        }}
                    />
                </div>
            ))}
        </div>
    );
};

// === КОМПОНЕНТ БАННЕРА ===
const NewYearBanner = () => {
    const [isVisible, setIsVisible] = React.useState(true);
    if (!isVisible) return null;

    return (
        <div style={{
            background: 'linear-gradient(90deg, #c41e3a 0%, #1a472a 50%, #c41e3a 100%)',
            padding: '12px 20px',
            position: 'relative',
            textAlign: 'center'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '15px',
                color: 'white'
            }}>
                <span style={{ fontSize: '24px' }} className="bounce-item">🎄</span>
                <div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>С Новым 2026 Годом!</div>
                    <div style={{ fontSize: '12px', opacity: 0.9 }}>Желаем успехов и процветания!</div>
                </div>
                <span style={{ fontSize: '24px' }} className="bounce-item">🎅</span>
            </div>
            <button
                onClick={() => setIsVisible(false)}
                style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    color: 'white',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    fontSize: '12px'
                }}
            >
                ✕
            </button>
        </div>
    );
};

// === УКРАШЕНИЯ ДЛЯ SIDEBAR ===
const SidebarDecorations = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        padding: '15px',
        background: 'linear-gradient(135deg, rgba(196, 30, 58, 0.2) 0%, rgba(26, 71, 42, 0.2) 100%)',
        borderRadius: '12px',
        marginBottom: '15px'
    }}>
        <span style={{ fontSize: '28px' }} className="swing-item">🎄</span>
        <span style={{ fontSize: '28px' }} className="pulse-item">⭐</span>
        <span style={{ fontSize: '28px' }} className="swing-item">🎁</span>
    </div>
);

// === СТИЛИ ДЛЯ АНИМАЦИЙ ===
const NewYearStyles = () => (
    <style>{`
        @keyframes snowfallAnim {
            0% { transform: translateY(-50px) rotate(0deg); }
            100% { transform: translateY(100vh) rotate(360deg); }
        }
        @keyframes twinkleAnim {
            0% { opacity: 0.4; }
            100% { opacity: 1; }
        }
        @keyframes bounceAnim {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
        }
        @keyframes swingAnim {
            0%, 100% { transform: rotate(-10deg); }
            50% { transform: rotate(10deg); }
        }
        @keyframes pulseAnim {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.2); }
        }
        .bounce-item { animation: bounceAnim 1s ease infinite; }
        .swing-item { animation: swingAnim 2s ease-in-out infinite; }
        .pulse-item { animation: pulseAnim 1.5s ease-in-out infinite; }

        .ny-header-border {
            border-bottom: 2px solid transparent !important;
            border-image: linear-gradient(90deg, #c41e3a, #ffd700, #1a472a, #ffd700, #c41e3a) 1 !important;
        }
        .ny-gold {
            color: #ffd700 !important;
            text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
        }
    `}</style>
);
// Компонент предпросмотра
const BusinessCardPreview = ({ card }) => {
    const [activeSlide, setActiveSlide] = React.useState(0);

    const primaryColor = card.primary_color || '#0891b2';

    // Генерация аватара
    const avatarUrl = card.photo_url ||
        `https://ui-avatars.com/api/?name=${encodeURIComponent(card.full_name || 'User')}&size=200&background=${primaryColor.replace('#', '')}&color=fff`;

    return (
        <div className="max-w-md mx-auto">
            {/* Переключатель слайдов */}
            <div className="flex justify-center gap-2 mb-4">
                <button
                    onClick={() => setActiveSlide(0)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                        activeSlide === 0
                            ? 'text-white shadow-lg'
                            : 'bg-white/10 text-white/70 hover:bg-white/20'
                    }`}
                    style={activeSlide === 0 ? { backgroundColor: primaryColor } : {}}
                >
                    Слайд 1
                </button>
                <button
                    onClick={() => setActiveSlide(1)}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                        activeSlide === 1
                            ? 'text-white shadow-lg'
                            : 'bg-white/10 text-white/70 hover:bg-white/20'
                    }`}
                    style={activeSlide === 1 ? { backgroundColor: primaryColor } : {}}
                >
                    Слайд 2
                </button>
            </div>

            {/* Контейнер визитки */}
            <div
                className="rounded-3xl overflow-hidden shadow-2xl"
                style={{
                    background: `linear-gradient(135deg, ${primaryColor}22 0%, ${primaryColor}11 100%)`,
                    border: `1px solid ${primaryColor}33`
                }}
            >
                {/* СЛАЙД 1 */}
                {activeSlide === 0 && (
                    <div className="p-6">
                        {/* Фото */}
                        <div className="flex justify-center mb-4">
                            <div
                                className="w-28 h-28 rounded-full overflow-hidden shadow-xl"
                                style={{ border: `4px solid ${primaryColor}` }}
                            >
                                <img
                                    src={avatarUrl}
                                    alt={card.full_name}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        </div>

                        {/* Имя и должность */}
                        <div className="text-center mb-4">
                            <h2 className="text-2xl font-bold text-white mb-1">
                                {card.full_name || 'Имя Фамилия'}
                            </h2>
                            {card.position && (
                                <span
                                    className="inline-block px-3 py-1 rounded-full text-sm text-white/90"
                                    style={{ backgroundColor: `${primaryColor}66` }}
                                >
                                    {card.position}
                                </span>
                            )}
                        </div>

                        {/* Телефон */}
                        {card.phone && (
                            <div className="flex justify-center mb-4">
                                <a
                                    href={`tel:${card.phone}`}
                                    className="flex items-center gap-2 px-4 py-2 rounded-full text-white font-medium transition-transform hover:scale-105"
                                    style={{ backgroundColor: primaryColor }}
                                >
                                    📞 {card.phone}
                                </a>
                            </div>
                        )}

                        {/* Мессенджеры */}
                        <div className="flex justify-center gap-3 mb-4">
                            {card.telegram && (
                                <a href={`https://t.me/${card.telegram.replace('@', '')}`}
                                   className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white hover:scale-110 transition-transform">
                                    ✈️
                                </a>
                            )}
                            {card.whatsapp && (
                                <a href={`https://wa.me/${card.whatsapp.replace(/[^0-9]/g, '')}`}
                                   className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white hover:scale-110 transition-transform">
                                    💬
                                </a>
                            )}
                            {card.viber && (
                                <a href={`viber://chat?number=${card.viber.replace(/[^0-9]/g, '')}`}
                                   className="w-10 h-10 rounded-full bg-purple-500 flex items-center justify-center text-white hover:scale-110 transition-transform">
                                    📱
                                </a>
                            )}
                            {card.imo && (
                                <a href={`imo://chat?phone=${card.imo}`}
                                   className="w-10 h-10 rounded-full bg-cyan-500 flex items-center justify-center text-white hover:scale-110 transition-transform">
                                    💭
                                </a>
                            )}
                        </div>

                        {/* Слоган */}
                        {card.slogan && (
                            <div className="text-center mb-4 px-4">
                                <p className="text-white/80 italic text-sm">"{card.slogan}"</p>
                            </div>
                        )}

                        {/* Соцсети */}
                        <div className="flex flex-wrap justify-center gap-2 mb-4">
                            {card.vk && (
                                <a href={card.vk} className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-xs hover:bg-blue-700">
                                    VK
                                </a>
                            )}
                            {card.youtube && (
                                <a href={card.youtube} className="px-3 py-1.5 rounded-lg bg-red-600 text-white text-xs hover:bg-red-700">
                                    YouTube
                                </a>
                            )}
                            {card.instagram && (
                                <a href={`https://instagram.com/${card.instagram.replace('@', '')}`} className="px-3 py-1.5 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs">
                                    Instagram
                                </a>
                            )}
                            {card.facebook && (
                                <a href={card.facebook} className="px-3 py-1.5 rounded-lg bg-blue-700 text-white text-xs hover:bg-blue-800">
                                    Facebook
                                </a>
                            )}
                            {card.rutube && (
                                <a href={card.rutube} className="px-3 py-1.5 rounded-lg bg-gray-700 text-white text-xs hover:bg-gray-800">
                                    Rutube
                                </a>
                            )}
                            {card.tiktok && (
                                <a href={card.tiktok} className="px-3 py-1.5 rounded-lg bg-black text-white text-xs hover:bg-gray-900">
                                    TikTok
                                </a>
                            )}
                        </div>

                        {/* CTA кнопка */}
                        <div className="text-center">
                            <button
                                className="px-6 py-3 rounded-xl text-white font-semibold shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
                                style={{ backgroundColor: primaryColor }}
                            >
                                🚀 Присоединиться к команде
                            </button>
                        </div>
                    </div>
                )}

                {/* СЛАЙД 2 */}
                {activeSlide === 1 && (
                    <div className="p-6">
                        {/* О себе */}
                        {card.about && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold text-white mb-2 flex items-center gap-2">
                                    <span style={{ color: primaryColor }}>●</span> Обо мне
                                </h3>
                                <p className="text-white/80 text-sm leading-relaxed">
                                    {card.about}
                                </p>
                            </div>
                        )}

                        {/* Галерея */}
                        {card.gallery_photos && card.gallery_photos.length > 0 && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold text-white mb-2 flex items-center gap-2">
                                    <span style={{ color: primaryColor }}>●</span> Галерея
                                </h3>
                                <div className="flex gap-2 overflow-x-auto pb-2">
                                    {card.gallery_photos.map((photo, idx) => (
                                        <img
                                            key={idx}
                                            src={photo}
                                            alt={`Фото ${idx + 1}`}
                                            className="w-20 h-20 rounded-lg object-cover flex-shrink-0"
                                        />
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Видео */}
                        {card.video_links && card.video_links.length > 0 && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold text-white mb-2 flex items-center gap-2">
                                    <span style={{ color: primaryColor }}>●</span> Видео
                                </h3>
                                <div className="space-y-2">
                                    {card.video_links.map((video, idx) => (
                                        <a
                                            key={idx}
                                            href={video.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex items-center gap-3 p-3 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
                                        >
                                            <span className="text-2xl">▶️</span>
                                            <span className="text-white text-sm">
                                                {video.title || 'Смотреть видео'}
                                            </span>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Регистрация */}
                        {card.registration_text && (
                            <div
                                className="p-4 rounded-xl text-center"
                                style={{ backgroundColor: `${primaryColor}33` }}
                            >
                                <p className="text-white/90 text-sm mb-3">{card.registration_text}</p>
                                <button
                                    className="px-5 py-2 rounded-lg text-white font-medium"
                                    style={{ backgroundColor: primaryColor }}
                                >
                                    Регистрация
                                </button>
                            </div>
                        )}

                        {/* Если нет контента для 2 слайда */}
                        {!card.about && (!card.gallery_photos || card.gallery_photos.length === 0) &&
                            (!card.video_links || card.video_links.length === 0) && !card.registration_text && (
                                <div className="text-center py-8 text-white/50">
                                    <p>Заполните поля "О себе", добавьте галерею или видео</p>
                                </div>
                            )}
                    </div>
                )}

                {/* Индикаторы слайдов */}
                <div className="flex justify-center gap-2 pb-4">
                    <div
                        className={`w-2 h-2 rounded-full transition-all ${activeSlide === 0 ? 'w-6' : 'bg-white/30'}`}
                        style={activeSlide === 0 ? { backgroundColor: primaryColor } : {}}
                    />
                    <div
                        className={`w-2 h-2 rounded-full transition-all ${activeSlide === 1 ? 'w-6' : 'bg-white/30'}`}
                        style={activeSlide === 1 ? { backgroundColor: primaryColor } : {}}
                    />
                </div>
            </div>
        </div>
    );
};
const initialCardForm = {
    card_title: '',
    full_name: '',
    position: '',
    phone: '',
    email: '',
    // Мессенджеры
    telegram: '',
    whatsapp: '',
    viber: '',
    imo: '',
    // Соцсети
    vk: '',
    instagram: '',
    youtube: '',
    facebook: '',
    rutube: '',
    tiktok: '',
    // Контент
    about: '',
    achievements: '',
    slogan: '',
    // Медиа
    photo_url: '',
    background_url: '',
    gallery_photos: [],
    video_links: [],
    music_url: '',
    // Настройки
    registration_text: '',
    theme: 'light',
    primary_color: '#0891b2',
    is_active: true
};
// Компонент редактора
const BusinessCardEditor = ({
                                cardForm,
                                setCardForm,
                                cardLoading,
                                saveBusinessCard,
                                businessCard,
                                toggleCardActive,
                                shareBusinessCard,
                                setActiveTab
                            }) => {
    const [previewMode, setPreviewMode] = React.useState(false);
    const [activeSection, setActiveSection] = React.useState('basic');

    if (cardLoading && !businessCard) {
        return (
            <div className="flex items-center justify-center h-64">
                <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
            </div>
        );
    }

    // Добавление фото в галерею
    const addGalleryPhoto = () => {
        const photos = cardForm.gallery_photos || [];
        if (photos.length < 10) {
            setCardForm({
                ...cardForm,
                gallery_photos: [...photos, '']
            });
        }
    };

    // Удаление фото из галереи
    const removeGalleryPhoto = (index) => {
        const photos = [...(cardForm.gallery_photos || [])];
        photos.splice(index, 1);
        setCardForm({ ...cardForm, gallery_photos: photos });
    };

    // Обновление фото в галерее
    const updateGalleryPhoto = (index, value) => {
        const photos = [...(cardForm.gallery_photos || [])];
        photos[index] = value;
        setCardForm({ ...cardForm, gallery_photos: photos });
    };

    // Добавление видео ссылки
    const addVideoLink = () => {
        const links = cardForm.video_links || [];
        if (links.length < 5) {
            setCardForm({
                ...cardForm,
                video_links: [...links, { url: '', title: '' }]
            });
        }
    };

    // Удаление видео ссылки
    const removeVideoLink = (index) => {
        const links = [...(cardForm.video_links || [])];
        links.splice(index, 1);
        setCardForm({ ...cardForm, video_links: links });
    };

    // Обновление видео ссылки
    const updateVideoLink = (index, field, value) => {
        const links = [...(cardForm.video_links || [])];
        links[index] = { ...links[index], [field]: value };
        setCardForm({ ...cardForm, video_links: links });
    };

    const sections = [
        { id: 'basic', label: 'Основное', icon: User },
        { id: 'messengers', label: 'Мессенджеры', icon: MessageCircle },
        { id: 'socials', label: 'Соцсети', icon: Globe },
        { id: 'media', label: 'Медиа', icon: ImageIcon },
        { id: 'settings', label: 'Настройки', icon: Settings }
    ];

    return (
        <div className="max-w-6xl mx-auto">
            {/* Заголовок */}
            <div className="mb-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <CreditCard className="w-8 h-8 text-cyan-600" />
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Моя визитка</h1>
                </div>

                <div className="flex flex-wrap gap-2">
                    <button
                        onClick={() => setPreviewMode(!previewMode)}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center gap-2 text-sm"
                    >
                        <Eye className="w-4 h-4" />
                        {previewMode ? 'Редактировать' : 'Предпросмотр'}
                    </button>

                    {businessCard && (
                        <>
                            <button
                                onClick={shareBusinessCard}
                                className="px-4 py-2 bg-cyan-100 text-cyan-700 rounded-lg hover:bg-cyan-200 flex items-center gap-2 text-sm"
                            >
                                <Share2 className="w-4 h-4" />
                                Поделиться
                            </button>

                            <button
                                onClick={toggleCardActive}
                                className={`px-4 py-2 rounded-lg flex items-center gap-2 text-sm ${
                                    businessCard.is_active
                                        ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                        : 'bg-red-100 text-red-700 hover:bg-red-200'
                                }`}
                            >
                                {businessCard.is_active ? '✓ Активна' : '✗ Неактивна'}
                            </button>
                        </>
                    )}
                </div>
            </div>

            {previewMode ? (
                <BusinessCardPreview card={cardForm} />
            ) : (
                <>
                    {/* Навигация по секциям */}
                    <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
                        {sections.map(section => (
                            <button
                                key={section.id}
                                onClick={() => setActiveSection(section.id)}
                                className={`flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap transition-all ${
                                    activeSection === section.id
                                        ? 'bg-cyan-600 text-white shadow-lg'
                                        : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
                                }`}
                            >
                                <section.icon className="w-4 h-4" />
                                {section.label}
                            </button>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {/* === ОСНОВНАЯ ИНФОРМАЦИЯ === */}
                        {activeSection === 'basic' && (
                            <>
                                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                    <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                        <User className="w-5 h-5 text-cyan-600" />
                                        Личные данные
                                    </h3>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Название визитки
                                            </label>
                                            <input
                                                type="text"
                                                value={cardForm.card_title || ''}
                                                onChange={(e) => setCardForm({...cardForm, card_title: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="Моя основная визитка"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Для удобства в списке</p>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">ФИО *</label>
                                            <input
                                                type="text"
                                                value={cardForm.full_name || ''}
                                                onChange={(e) => setCardForm({...cardForm, full_name: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="Иванов Иван"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Должность</label>
                                            <input
                                                type="text"
                                                value={cardForm.position || ''}
                                                onChange={(e) => setCardForm({...cardForm, position: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="Независимый партнёр CONCORD"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Телефон</label>
                                            <input
                                                type="tel"
                                                value={cardForm.phone || ''}
                                                onChange={(e) => setCardForm({...cardForm, phone: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="+7-916-123-45-67"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                            <input
                                                type="email"
                                                value={cardForm.email || ''}
                                                onChange={(e) => setCardForm({...cardForm, email: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="email@example.com"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                    <h3 className="text-lg font-semibold mb-4">О себе и слоган</h3>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Слоган (отображается на 1 слайде)
                                            </label>
                                            <textarea
                                                value={cardForm.slogan || ''}
                                                onChange={(e) => setCardForm({...cardForm, slogan: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                rows="2"
                                                maxLength="200"
                                                placeholder="Ваш мотивирующий слоган в 2 строки"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">{(cardForm.slogan || '').length}/200</p>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Описание о себе (отображается на 2 слайде)
                                            </label>
                                            <textarea
                                                value={cardForm.about || ''}
                                                onChange={(e) => setCardForm({...cardForm, about: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                rows="4"
                                                maxLength="1000"
                                                placeholder="Расскажите о себе..."
                                            />
                                            <p className="text-xs text-gray-500 mt-1">{(cardForm.about || '').length}/1000</p>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Текст для регистрации
                                            </label>
                                            <textarea
                                                value={cardForm.registration_text || ''}
                                                onChange={(e) => setCardForm({...cardForm, registration_text: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                rows="2"
                                                maxLength="500"
                                                placeholder="Слоган для регистрации в CONCORD"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* === МЕССЕНДЖЕРЫ === */}
                        {activeSection === 'messengers' && (
                            <div className="lg:col-span-2 bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                    <MessageCircle className="w-5 h-5 text-cyan-600" />
                                    Мессенджеры
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs">✈</span>
                                                Telegram
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            value={cardForm.telegram || ''}
                                            onChange={(e) => setCardForm({...cardForm, telegram: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="@username"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center text-white text-xs">💬</span>
                                                WhatsApp
                                            </span>
                                        </label>
                                        <input
                                            type="tel"
                                            value={cardForm.whatsapp || ''}
                                            onChange={(e) => setCardForm({...cardForm, whatsapp: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="+7 (999) 123-45-67"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-purple-500 rounded-full flex items-center justify-center text-white text-xs">V</span>
                                                Viber
                                            </span>
                                        </label>
                                        <input
                                            type="tel"
                                            value={cardForm.viber || ''}
                                            onChange={(e) => setCardForm({...cardForm, viber: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="+7 (999) 123-45-67"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-cyan-500 rounded-full flex items-center justify-center text-white text-xs">i</span>
                                                imo
                                            </span>
                                        </label>
                                        <input
                                            type="tel"
                                            value={cardForm.imo || ''}
                                            onChange={(e) => setCardForm({...cardForm, imo: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="+7 (999) 123-45-67"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* === СОЦСЕТИ === */}
                        {activeSection === 'socials' && (
                            <div className="lg:col-span-2 bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                    <Globe className="w-5 h-5 text-cyan-600" />
                                    Социальные сети
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-blue-600 rounded flex items-center justify-center text-white text-xs font-bold">VK</span>
                                                ВКонтакте
                                            </span>
                                        </label>
                                        <input
                                            type="url"
                                            value={cardForm.vk || ''}
                                            onChange={(e) => setCardForm({...cardForm, vk: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="https://vk.com/username"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 rounded flex items-center justify-center text-white text-xs">📷</span>
                                                Instagram
                                            </span>
                                        </label>
                                        <input
                                            type="text"
                                            value={cardForm.instagram || ''}
                                            onChange={(e) => setCardForm({...cardForm, instagram: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="@username"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-red-600 rounded flex items-center justify-center text-white text-xs">▶</span>
                                                YouTube
                                            </span>
                                        </label>
                                        <input
                                            type="url"
                                            value={cardForm.youtube || ''}
                                            onChange={(e) => setCardForm({...cardForm, youtube: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="https://youtube.com/@channel"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-blue-700 rounded flex items-center justify-center text-white text-xs font-bold">f</span>
                                                Facebook
                                            </span>
                                        </label>
                                        <input
                                            type="url"
                                            value={cardForm.facebook || ''}
                                            onChange={(e) => setCardForm({...cardForm, facebook: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="https://facebook.com/username"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-gray-800 rounded flex items-center justify-center text-white text-xs font-bold">R</span>
                                                Rutube
                                            </span>
                                        </label>
                                        <input
                                            type="url"
                                            value={cardForm.rutube || ''}
                                            onChange={(e) => setCardForm({...cardForm, rutube: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="https://rutube.ru/channel/..."
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            <span className="inline-flex items-center gap-2">
                                                <span className="w-5 h-5 bg-black rounded flex items-center justify-center text-white text-xs font-bold">T</span>
                                                TikTok
                                            </span>
                                        </label>
                                        <input
                                            type="url"
                                            value={cardForm.tiktok || ''}
                                            onChange={(e) => setCardForm({...cardForm, tiktok: e.target.value})}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                            placeholder="https://tiktok.com/@username"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* === МЕДИА === */}
                        {activeSection === 'media' && (
                            <>
                                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                    <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                        <ImageIcon className="w-5 h-5 text-cyan-600" />
                                        Фото и фон
                                    </h3>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">URL фотографии</label>
                                            <input
                                                type="url"
                                                value={cardForm.photo_url || ''}
                                                onChange={(e) => setCardForm({...cardForm, photo_url: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="https://example.com/photo.jpg"
                                            />
                                            {cardForm.photo_url && (
                                                <img src={cardForm.photo_url} alt="Preview" className="mt-2 w-24 h-24 object-cover rounded-full border-2 border-gray-200" />
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">URL фона</label>
                                            <input
                                                type="url"
                                                value={cardForm.background_url || ''}
                                                onChange={(e) => setCardForm({...cardForm, background_url: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="https://example.com/background.jpg"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                🎵 URL музыки (MP3)
                                            </label>
                                            <input
                                                type="url"
                                                value={cardForm.music_url || ''}
                                                onChange={(e) => setCardForm({...cardForm, music_url: e.target.value})}
                                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="https://example.com/music.mp3"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Будет отображаться индикатор музыки</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                    <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                        🖼️ Галерея фото
                                        <span className="text-sm font-normal text-gray-500">
                                            ({(cardForm.gallery_photos || []).length}/10)
                                        </span>
                                    </h3>

                                    <div className="space-y-3">
                                        {(cardForm.gallery_photos || []).map((url, index) => (
                                            <div key={index} className="flex gap-2">
                                                <input
                                                    type="url"
                                                    value={url}
                                                    onChange={(e) => updateGalleryPhoto(index, e.target.value)}
                                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                    placeholder={`URL фото ${index + 1}`}
                                                />
                                                <button
                                                    onClick={() => removeGalleryPhoto(index)}
                                                    className="px-3 py-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200"
                                                >
                                                    <Trash2 className="w-4 h-4" />
                                                </button>
                                            </div>
                                        ))}

                                        {(cardForm.gallery_photos || []).length < 10 && (
                                            <button
                                                onClick={addGalleryPhoto}
                                                className="w-full px-4 py-2 border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:border-cyan-500 hover:text-cyan-600 flex items-center justify-center gap-2"
                                            >
                                                <Plus className="w-4 h-4" />
                                                Добавить фото
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <div className="lg:col-span-2 bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                    <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                        🎬 Видео ссылки
                                        <span className="text-sm font-normal text-gray-500">
                                            ({(cardForm.video_links || []).length}/5)
                                        </span>
                                    </h3>

                                    <div className="space-y-4">
                                        {(cardForm.video_links || []).map((link, index) => (
                                            <div key={index} className="p-4 bg-gray-50 rounded-lg">
                                                <div className="flex gap-2 mb-2">
                                                    <input
                                                        type="url"
                                                        value={link.url}
                                                        onChange={(e) => updateVideoLink(index, 'url', e.target.value)}
                                                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                        placeholder="URL видео (YouTube, Rutube и др.)"
                                                    />
                                                    <button
                                                        onClick={() => removeVideoLink(index)}
                                                        className="px-3 py-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200"
                                                    >
                                                        <Trash2 className="w-4 h-4" />
                                                    </button>
                                                </div>
                                                <input
                                                    type="text"
                                                    value={link.title}
                                                    onChange={(e) => updateVideoLink(index, 'title', e.target.value)}
                                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                    placeholder="Текст призыва к действию"
                                                />
                                            </div>
                                        ))}

                                        {(cardForm.video_links || []).length < 5 && (
                                            <button
                                                onClick={addVideoLink}
                                                className="w-full px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:border-cyan-500 hover:text-cyan-600 flex items-center justify-center gap-2"
                                            >
                                                <Plus className="w-4 h-4" />
                                                Добавить видео
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                        {/* === НАСТРОЙКИ === */}
                        {activeSection === 'settings' && (
                            <div className="lg:col-span-2 bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                                <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                                    <Settings className="w-5 h-5 text-cyan-600" />
                                    Оформление
                                </h3>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Тема</label>
                                        <div className="grid grid-cols-2 gap-2">
                                            {['light', 'dark', 'gradient', 'corporate'].map(theme => (
                                                <button
                                                    key={theme}
                                                    onClick={() => setCardForm({...cardForm, theme})}
                                                    className={`px-4 py-3 rounded-lg border-2 transition-all ${
                                                        cardForm.theme === theme
                                                            ? 'border-cyan-600 bg-cyan-50'
                                                            : 'border-gray-200 hover:border-gray-300'
                                                    }`}
                                                >
                                                    {theme === 'light' && '☀️ Светлая'}
                                                    {theme === 'dark' && '🌙 Тёмная'}
                                                    {theme === 'gradient' && '🌈 Градиент'}
                                                    {theme === 'corporate' && '💼 Корпоративная'}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Основной цвет</label>
                                        <div className="flex gap-2">
                                            <input
                                                type="color"
                                                value={cardForm.primary_color || '#0891b2'}
                                                onChange={(e) => setCardForm({...cardForm, primary_color: e.target.value})}
                                                className="w-20 h-12 rounded-lg border border-gray-300 cursor-pointer"
                                            />
                                            <input
                                                type="text"
                                                value={cardForm.primary_color || '#0891b2'}
                                                onChange={(e) => setCardForm({...cardForm, primary_color: e.target.value})}
                                                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                                                placeholder="#0891b2"
                                            />
                                        </div>

                                        {/* Предустановленные цвета */}
                                        <div className="flex gap-2 mt-3">
                                            {['#0891b2', '#7c3aed', '#059669', '#dc2626', '#f59e0b', '#6366f1'].map(color => (
                                                <button
                                                    key={color}
                                                    onClick={() => setCardForm({...cardForm, primary_color: color})}
                                                    className={`w-8 h-8 rounded-full border-2 transition-transform hover:scale-110 ${
                                                        cardForm.primary_color === color ? 'border-gray-800 scale-110' : 'border-transparent'
                                                    }`}
                                                    style={{ backgroundColor: color }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* Кнопка сохранения */}
            {!previewMode && (
                <div className="mt-6 flex flex-col sm:flex-row justify-end gap-3">
                    <button
                        onClick={() => setActiveTab('business-card')}
                        className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-medium"
                    >
                        Назад к списку
                    </button>
                    <button
                        onClick={saveBusinessCard}
                        disabled={cardLoading}
                        className="px-8 py-3 bg-gradient-to-r from-cyan-600 to-blue-600 text-white rounded-lg hover:from-cyan-700 hover:to-blue-700 font-medium disabled:opacity-50 flex items-center justify-center gap-2 shadow-lg"
                    >
                        {cardLoading ? (
                            <>
                                <Loader2 className="w-5 h-5 animate-spin" />
                                Сохранение...
                            </>
                        ) : (
                            <>
                                💾 Сохранить визитку
                            </>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

// Компонент карточки визитки в списке
const BusinessCardItem = ({card, onEdit, onDelete, onToggleActive, onSetDefault, onShare}) => {
    return (
        <div className={`bg-white rounded-xl p-6 shadow-sm border-2 transition-all ${
            card.is_default ? 'border-indigo-600' : 'border-gray-200'
        }`}>
            {/* Заголовок */}
            <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                        <h3 className="text-lg font-semibold text-gray-900">
                            {card.card_title || card.full_name}
                        </h3>
                        {card.is_default && (
                            <span className="px-2 py-1 bg-indigo-100 text-indigo-700 text-xs font-medium rounded">
                                По умолчанию
                            </span>
                        )}
                        <span className={`px-2 py-1 text-xs font-medium rounded ${
                            card.is_active
                                ? 'bg-green-100 text-green-700'
                                : 'bg-gray-100 text-gray-600'
                        }`}>
                            {card.is_active ? 'Активна' : 'Неактивна'}
                        </span>
                    </div>
                    <p className="text-sm text-gray-600">{card.full_name}</p>
                    {card.position && (
                        <p className="text-sm text-gray-500">{card.position}</p>
                    )}
                </div>
            </div>

            {/* Статистика */}
            <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
                <div className="flex items-center gap-1">
                    <Eye className="w-4 h-4" />
                    <span>{card.views_count} просмотров</span>
                </div>
                <div className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    <span>{new Date(card.created_at).toLocaleDateString('ru-RU')}</span>
                </div>
            </div>

            {/* Публичная ссылка */}
            <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                <p className="text-xs text-gray-500 mb-1">Публичная ссылка:</p>
                <div className="flex items-center gap-2">
                    <code className="text-xs text-indigo-600 flex-1 truncate">
                        {card.public_url}
                    </code>
                    <button
                        onClick={(e) => {
                            navigator.clipboard.writeText(card.public_url).then(() => {
                                if (window.Telegram?.WebApp) {
                                    window.Telegram.WebApp.showAlert('Ссылка скопирована!');
                                } else {
                                    // Визуальная обратная связь
                                    const btn = e.currentTarget;
                                    btn.classList.add('bg-green-100');
                                    const originalHTML = btn.innerHTML;
                                    btn.innerHTML = '<svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>';

                                    setTimeout(() => {
                                        btn.innerHTML = originalHTML;
                                        btn.classList.remove('bg-green-100');
                                    }, 2000);
                                }
                            }).catch(err => {
                                console.error('Ошибка копирования:', err);
                            });
                        }}
                        className="p-1 hover:bg-gray-200 rounded transition-colors"
                        title="Копировать ссылку"
                    >
                        <Copy className="w-4 h-4 text-gray-600"/>
                    </button>
                </div>
            </div>



            {/* Действия */}
            <div className="flex gap-2 flex-wrap">
                <button
                    onClick={() => onEdit(card)}
                    className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center justify-center gap-2"
                >
                    <Edit3 className="w-4 h-4" />
                    Редактировать
                </button>

                {!card.is_default && (
                    <button
                        onClick={() => onSetDefault(card.id)}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center gap-2"
                        title="Сделать по умолчанию"
                    >
                        <Star className="w-4 h-4" />
                    </button>
                )}

                <button
                    onClick={() => onToggleActive(card.id)}
                    className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
                        card.is_active
                            ? 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
                            : 'bg-green-100 text-green-700 hover:bg-green-200'
                    }`}
                    title={card.is_active ? 'Деактивировать' : 'Активировать'}
                >
                    {card.is_active ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>

                <button
                    onClick={() => onDelete(card.id)}
                    className="px-4 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 flex items-center gap-2"
                    title="Удалить"
                >
                    <Trash2 className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

// Главный компонент списка визиток
const BusinessCardsList = ({
                               cards,
                               loading,
                               onCreateNew,
                               onEdit,
                               onDelete,
                               onToggleActive,
                               onSetDefault,
                               onShare,
                               onRefresh
                           }) => {
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
            </div>
        );
    }

    return (
        <div className="max-w-6xl mx-auto">
            {/* Заголовок */}
            <div className="mb-6 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <CreditCard className="w-8 h-8 text-indigo-600" />
                    <div>
                        <h1 className="text-3xl font-bold text-white">Мои визитки</h1>
                        <p className="text-white mt-1">
                            Всего визиток: {cards.length} • Просмотров: {cards.reduce((sum, card) => sum + card.views_count, 0)}
                        </p>
                    </div>
                </div>

                <div className="flex gap-2">
                    <button
                        onClick={onRefresh}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center gap-2"
                    >
                        <RefreshCw className="w-4 h-4" />
                        Обновить
                    </button>
                    <button
                        onClick={onCreateNew}
                        className="px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 flex items-center gap-2"
                    >
                        <Plus className="w-4 h-4" />
                        Создать визитку
                    </button>
                </div>
            </div>

            {/* Список визиток */}
            {cards.length === 0 ? (
                <div className="text-center py-16">
                    <CreditCard className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                    <h3 className="text-xl font-semibold text-gray-700 mb-2">
                        У вас пока нет визиток
                    </h3>
                    <p className="text-gray-500 mb-6">
                        Создайте свою первую визитку, чтобы делиться контактами
                    </p>
                    <button
                        onClick={onCreateNew}
                        className="px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 flex items-center gap-2 mx-auto"
                    >
                        <Plus className="w-5 h-5" />
                        Создать первую визитку
                    </button>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {cards.map(card => (
                        <BusinessCardItem
                            key={card.id}
                            card={card}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            onToggleActive={onToggleActive}
                            onSetDefault={onSetDefault}
                            onShare={onShare}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
const ConcordWebApp = () => {
    const [activeTab, setActiveTab] = useState('home');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [expandedPartners, setExpandedPartners] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // API States
    const [generatedCheck, setGeneratedCheck] = useState(null);
    const [checkGenerating, setCheckGenerating] = useState(false);
    const [userData, setUserData] = useState(null);
    const [rewardsHistory, setRewardsHistory] = useState([]);
    const [partnersStructure, setPartnersStructure] = useState([]);
    const [marketingData, setMarketingData] = useState(null);
    const [marketingTreeData, setMarketingTreeData] = useState(null);
    const [marketingSearchId, setMarketingSearchId] = useState('');
    const [marketingLoading, setMarketingLoading] = useState(false);
    const [rewardsStats, setRewardsStats] = useState(null);
    const [withdrawalRequests, setWithdrawalRequests] = useState([]);
    const [token, setToken] = useState(localStorage.getItem('concord_token') || null);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [currentUserInfo, setCurrentUserInfo] = useState(null);
    const [navigationStack, setNavigationStack] = useState([]);
    const [operationsHistory, setOperationsHistory] = useState([]);
    const [operationsStats, setOperationsStats] = useState(null);
    const [operationsFilter, setOperationsFilter] = useState({
        type: 'all',
        status: 'all',
        date_from: '',
        date_to: ''
    });
    const [operationsPage, setOperationsPage] = useState(1);
    const [operationsLoading, setOperationsLoading] = useState(false);
    const [operationsTotal, setOperationsTotal] = useState(0);
    const [hasMoreOperations, setHasMoreOperations] = useState(true);
    const [businessCards, setBusinessCards] = useState([]); // Список всех визиток
    const [currentCardId, setCurrentCardId] = useState(null); // ID текущей визитки
    const [cardsLoading, setCardsLoading] = useState(false);
    const [showCardEditor, setShowCardEditor] = useState(false); // Показать редактор или список
    const [businessCard, setBusinessCard] = useState(null);
    const [cardLoading, setCardLoading] = useState(false);
    // 3. ОБНОВИТЬ cardForm (добавить card_title):
    const [cardForm, setCardForm] = useState({
        card_title: '', // НОВОЕ ПОЛЕ
        full_name: '',
        position: '',
        phone: '',
        email: '',
        telegram: '',
        whatsapp: '',
        vk: '',
        instagram: '',
        about: '',
        achievements: '',
        photo_url: '',
        background_url: '',
        theme: 'light',
        primary_color: '#667eea',
        is_active: true
    });
    // API Functions
    const apiCall = async (endpoint, options = {}) => {
        try {
            const response = await fetch(`${API_BASE}${endpoint}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                    ...options.headers
                },
                ...options
            });

            const data = await response.json();

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('concord_token');
                    setToken(null);
                    setUserData(null);
                    window.location.reload();
                    throw new Error('Необходима повторная авторизация');
                }
                throw new Error(data.message || 'API Error');
            }

            return data;
        } catch (err) {
            console.error('API Error:', err);
            throw err;
        }
    };

    // Initialize Telegram WebApp
    const initializeTelegramWebApp = () => {
        const fragment = window.location.hash.substring(1);
        const fragmentParams = new URLSearchParams(fragment);
        const searchParams = new URLSearchParams(window.location.search);

        const telegramData = {
            windowTelegram: !!window.Telegram,
            windowTelegramWebApp: !!window.Telegram?.WebApp,
            initData: window.Telegram?.WebApp?.initData,
            initDataUnsafe: window.Telegram?.WebApp?.initDataUnsafe,
            user: window.Telegram?.WebApp?.initDataUnsafe?.user,
            urlParams: Object.fromEntries(searchParams),
            fragmentParams: Object.fromEntries(fragmentParams)
        };

        if (window.Telegram?.WebApp?.initData) {
            try {
                const params = new URLSearchParams(window.Telegram.WebApp.initData);
                telegramData.parsedInitData = Object.fromEntries(params);
            } catch (e) {
                console.error('Failed to parse initData', e);
            }
        }

        const tgWebAppData = fragmentParams.get('tgWebAppData');
        if (tgWebAppData) {
            try {
                const decodedData = decodeURIComponent(tgWebAppData);
                const dataParams = new URLSearchParams(decodedData);
                telegramData.tgWebAppData = {
                    raw: tgWebAppData,
                    decoded: decodedData,
                    parsed: Object.fromEntries(dataParams)
                };

                const userParam = dataParams.get('user');
                if (userParam) {
                    try {
                        telegramData.tgWebAppData.user = JSON.parse(decodeURIComponent(userParam));
                    } catch (e) {
                        console.error('Failed to parse user data', e);
                    }
                }
            } catch (e) {
                console.error('Failed to parse tgWebAppData', e);
            }
        }

        return telegramData;
    };

    // Load initial data
    useEffect(() => {
        const performAuth = async () => {
            const telegramData = initializeTelegramWebApp();
            let authData = null;

            // Strategy 1: Try Telegram WebApp standard API
            if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
                const webApp = window.Telegram.WebApp;
                webApp.expand();

                const user = webApp.initDataUnsafe.user;
                const initData = webApp.initData;

                const urlParams = new URLSearchParams(initData);
                const hash = urlParams.get('hash');
                const authDate = urlParams.get('auth_date');

                authData = {
                    telegram_id: user.id,
                    first_name: user.first_name || '',
                    last_name: user.last_name || '',
                    username: user.username || '',
                    auth_date: parseInt(authDate) || Math.floor(Date.now() / 1000),
                    hash: hash || 'webapp_auth'
                };
            }
            // Strategy 2: Try data from URL fragment (tgWebAppData)
            else if (telegramData.tgWebAppData?.user) {
                const user = telegramData.tgWebAppData.user;
                const parsed = telegramData.tgWebAppData.parsed;

                authData = {
                    telegram_id: user.id,
                    first_name: user.first_name || '',
                    last_name: user.last_name || '',
                    username: user.username || '',
                    auth_date: parseInt(parsed.auth_date) || Math.floor(Date.now() / 1000),
                    hash: parsed.hash || 'fragment_auth'
                };
            }
            // Strategy 3: Try URL search parameters
            else {
                const urlParams = new URLSearchParams(window.location.search);
                const telegramId = urlParams.get('telegram_id');

                if (telegramId) {
                    authData = {
                        telegram_id: parseInt(telegramId),
                        first_name: urlParams.get('first_name') || 'URLUser',
                        last_name: urlParams.get('last_name') || '',
                        username: urlParams.get('username') || 'urluser',
                        auth_date: parseInt(urlParams.get('auth_date')) || Math.floor(Date.now() / 1000),
                        hash: urlParams.get('hash') || 'url_auth'
                    };
                } else {
                    // Strategy 4: Demo data for development
                    authData = {
                        telegram_id: 7682902114,
                        first_name: "Demo",
                        last_name: "User",
                        username: "demouser",
                        auth_date: Math.floor(Date.now() / 1000),
                        hash: "demo_auth_" + Date.now()
                    };
                }
            }

            if (!authData) {
                throw new Error('Could not prepare authentication data');
            }

            // ПОДМЕНА ID ДЛЯ ТЕСТИРОВАНИЯ
            if (authData.telegram_id === 752775740) {
                console.log('🔄 ID substitution: 752775740 → 7682902114 for testing');
                authData.telegram_id = 7682902114;
            }
            if (authData.telegram_id === 123456789) {
                console.log('🔄 ID substitution: 752775740 → 7682902114 for testing');
                authData.telegram_id = 7682902114;
            }

            const loginResponse = await apiCall('/auth/telegram', {
                method: 'POST',
                body: JSON.stringify(authData)
            });

            if (loginResponse.success) {
                setToken(loginResponse.data.token);
                localStorage.setItem('concord_token', loginResponse.data.token);
                setUserData(loginResponse.data.user);

                if (window.Telegram?.WebApp) {
                    window.Telegram.WebApp.ready();
                }
            } else {
                throw new Error(loginResponse.message || 'Login failed');
            }
        };

        const initializeApp = async () => {
            if (token) {
                try {
                    const profileResponse = await apiCall('/user/profile');
                    if (profileResponse.success) {
                        setUserData(profileResponse.data);
                        await loadDashboardData();
                        setLoading(false);
                        return;
                    }
                } catch (err) {
                    console.error('Token validation failed:', err);
                    localStorage.removeItem('concord_token');
                    setToken(null);
                    setUserData(null);
                }
            }

            try {
                await performAuth();
                await loadDashboardData();
            } catch (err) {
                console.error('Auth error:', err);
                setError('Ошибка авторизации: ' + err.message);
            }

            setLoading(false);
        };

        initializeApp();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdown = document.getElementById('settings-dropdown');
            const settingsButton = event.target.closest('[data-settings-button]');

            if (dropdown && !dropdown.contains(event.target) && !settingsButton) {
                dropdown.classList.add('hidden');
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    // useEffect для загрузки маркетинговой структуры
    useEffect(() => {
        if (activeTab === 'structure' && !marketingTreeData && !marketingLoading) {
            loadMarketingTree();
        }
    }, [activeTab, marketingTreeData, marketingLoading]);
    // 4. Добавить useEffect для загрузки визитки:
    useEffect(() => {
        if (token && activeTab === 'business-card') {
            loadBusinessCards();
            setShowCardEditor(false); // Показать список при открытии вкладки
        }
    }, [token, activeTab]);


    // Загрузить визитку пользователя
    const loadBusinessCard = async () => {
        setCardLoading(true);
        try {
            const response = await apiCall('/cards/my');
            if (response.success) {
                setBusinessCard(response.data.card);
                // ИСПРАВЛЕНИЕ: Загрузить данные в форму
                setCardForm({
                    full_name: response.data.card.full_name || '',
                    position: response.data.card.position || '',
                    phone: response.data.card.phone || '',
                    email: response.data.card.email || '',
                    telegram: response.data.card.telegram || '',
                    whatsapp: response.data.card.whatsapp || '',
                    vk: response.data.card.vk || '',
                    instagram: response.data.card.instagram || '',
                    about: response.data.card.about || '',
                    achievements: response.data.card.achievements || '',
                    photo_url: response.data.card.photo_url || '',
                    background_url: response.data.card.background_url || '',
                    theme: response.data.card.theme || 'light',
                    primary_color: response.data.card.primary_color || '#667eea',
                    is_active: response.data.card.is_active !== undefined ? response.data.card.is_active : true
                });
            }
        } catch (err) {
            // Визитка еще не создана - оставить пустую форму
            console.log('Визитка не найдена, будет создана новая');
        } finally {
            setCardLoading(false);
        }
    };
    // Загрузить все визитки
    const loadBusinessCards = async () => {
        setCardsLoading(true);
        try {
            const response = await apiCall('/cards');
            if (response.success) {
                setBusinessCards(response.data.cards);
            }
        } catch (err) {
            console.error('Ошибка загрузки визиток:', err);
        } finally {
            setCardsLoading(false);
        }
    };
    // Загрузить конкретную визитку для редактирования
    const loadCardForEdit = async (cardId) => {
        setCardLoading(true);
        try {
            const response = await apiCall(`/cards/${cardId}`);
            if (response.success) {
                const card = response.data.card;
                setCurrentCardId(card.id);
                setCardForm({
                    card_title: card.card_title || '',
                    full_name: card.full_name || '',
                    position: card.position || '',
                    phone: card.phone || '',
                    email: card.email || '',
                    telegram: card.telegram || '',
                    whatsapp: card.whatsapp || '',
                    vk: card.vk || '',
                    instagram: card.instagram || '',
                    about: card.about || '',
                    achievements: card.achievements || '',
                    photo_url: card.photo_url || '',
                    background_url: card.background_url || '',
                    theme: card.theme || 'light',
                    primary_color: card.primary_color || '#667eea',
                    is_active: card.is_active !== undefined ? card.is_active : true
                });
                setShowCardEditor(true);
            }
        } catch (err) {
            alert('Ошибка загрузки визитки');
            console.error(err);
        } finally {
            setCardLoading(false);
        }
    };
    // Создать новую визитку
    const createNewCard = () => {
        setCurrentCardId(null);
        setCardForm({
            card_title: '',
            full_name: '',
            position: '',
            phone: '',
            email: '',
            telegram: '',
            whatsapp: '',
            vk: '',
            instagram: '',
            about: '',
            achievements: '',
            photo_url: '',
            background_url: '',
            theme: 'light',
            primary_color: '#667eea',
            is_active: true
        });
        setShowCardEditor(true);
    };
    // Сохранить визитку (создать или обновить)
    const saveBusinessCard = async () => {
        setCardLoading(true);
        try {
            const url = currentCardId ? `/cards/${currentCardId}` : '/cards';
            const method = currentCardId ? 'PUT' : 'POST';

            const response = await apiCall(url, {
                method: method,
                body: JSON.stringify(cardForm)
            });

            if (response.success) {
                alert(currentCardId ? 'Визитка обновлена!' : 'Визитка создана!');
                setShowCardEditor(false);
                await loadBusinessCards(); // Перезагрузить список
            }
        } catch (err) {
            alert('Ошибка сохранения визитки');
            console.error(err);
        } finally {
            setCardLoading(false);
        }
    };
    // Переключить активность
    const toggleCardActive = async (cardId) => {
        try {
            const response = await apiCall(`/cards/${cardId}/toggle-active`, {
                method: 'POST'
            });

            if (response.success) {
                await loadBusinessCards();
            }
        } catch (err) {
            alert('Ошибка изменения статуса');
            console.error(err);
        }
    };
    // Установить визитку по умолчанию
    const setCardAsDefault = async (cardId) => {
        try {
            const response = await apiCall(`/cards/${cardId}/set-default`, {
                method: 'POST'
            });

            if (response.success) {
                alert('Визитка установлена по умолчанию');
                await loadBusinessCards();
            }
        } catch (err) {
            alert('Ошибка установки по умолчанию');
            console.error(err);
        }
    };
    // Удалить визитку
    // Удалить визитку
    const deleteCard = async (cardId) => {
        // Функция для выполнения удаления
        const performDelete = async () => {
            try {
                const response = await apiCall(`/cards/${cardId}`, {
                    method: 'DELETE'
                });

                if (response.success) {
                    if (window.Telegram?.WebApp) {
                        window.Telegram.WebApp.showAlert('Визитка удалена');
                    } else {
                        alert('Визитка удалена');
                    }
                    await loadBusinessCards();
                }
            } catch (err) {
                if (window.Telegram?.WebApp) {
                    window.Telegram.WebApp.showAlert('Ошибка удаления визитки');
                } else {
                    alert('Ошибка удаления визитки');
                }
                console.error(err);
            }
        };

        // Показать подтверждение
        if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.showConfirm(
                'Вы уверены, что хотите удалить эту визитку?',
                (confirmed) => {
                    if (confirmed) {
                        performDelete();
                    }
                }
            );
        } else {
            if (window.confirm('Вы уверены, что хотите удалить эту визитку?')) {
                await performDelete();
            }
        }
    };

    // Поделиться визиткой
    const shareCard = async (card) => {
        const url = card.public_url;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: card.full_name,
                    text: `Визитка ${card.full_name}`,
                    url: url
                });
            } catch (err) {
                console.log('Ошибка шаринга', err);
            }
        } else {
            navigator.clipboard.writeText(url);
            alert('Ссылка скопирована в буфер обмена!');
        }
    };

// Поделиться визиткой
    const shareBusinessCard = async () => {
        if (!businessCard) return;

        const url = `https://card.b7774c.ru/${businessCard.slug}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: businessCard.full_name,
                    text: `Визитка ${businessCard.full_name}`,
                    url: url
                });
            } catch (err) {
                console.log('Ошибка при шаринге', err);
            }
        } else {
            // Копировать в буфер обмена
            navigator.clipboard.writeText(url);
            alert('Ссылка скопирована в буфер обмена!');
        }
    };
    const loadDashboardData = async () => {
        try {
            const promises = [];

            // Load user profile
            promises.push(
                apiCall('/user/profile').then(response => {
                    if (response.success) {
                        setUserData(response.data);
                    }
                }).catch(err => console.error('Profile load failed:', err))
            );

            // Load operations history (новый эндпоинт)
            promises.push(
                loadOperationsHistory(1, true)
            );

            // Load operations stats (новый эндпоинт)
            promises.push(
                apiCall('/operations/earnings-stats').then(response => {
                    if (response.success) {
                        setOperationsStats(response.data);
                    }
                }).catch(err => console.error('Operations stats load failed:', err))
            );

            // Load partners structure
            promises.push(
                apiCall('/user/partners').then(response => {
                    if (response.success) {
                        setPartnersStructure(response.data.teams || []);
                        setCurrentUserInfo(response.data.info || userData);
                        setCurrentUserId(userData?.id);
                        setNavigationStack([]);
                    }
                }).catch(err => console.error('Partners load failed:', err))
            );

            // Load marketing data
            promises.push(
                apiCall('/marketing/').then(response => {
                    if (response.success) {
                        setMarketingData(response.data);
                    }
                }).catch(err => console.error('Marketing load failed:', err))
            );

            // Load withdrawal requests
            promises.push(
                apiCall('/operations/withdrawal-requests').then(response => {
                    if (response.success) {
                        setWithdrawalRequests(response.data);
                    }
                }).catch(err => console.error('Withdrawals load failed:', err))
            );

            await Promise.allSettled(promises);
        } catch (err) {
            console.error('Failed to load dashboard data:', err);
        }
    };

    // Функция загрузки операций с пагинацией
    const loadOperationsHistory = async (page = 1, reset = false) => {
        if (operationsLoading) return;

        setOperationsLoading(true);
        try {
            const params = new URLSearchParams();
            params.append('page', page.toString());
            params.append('per_page', '10');

            if (operationsFilter.type !== 'all') params.append('type', operationsFilter.type);
            if (operationsFilter.status !== 'all') params.append('status', operationsFilter.status);
            if (operationsFilter.date_from) params.append('date_from', operationsFilter.date_from);
            if (operationsFilter.date_to) params.append('date_to', operationsFilter.date_to);

            const response = await apiCall(`/operations/history?${params.toString()}`);
            if (response.success) {
                if (reset) {
                    setOperationsHistory(response.data);
                } else {
                    setOperationsHistory(prev => [...prev, ...response.data]);
                }
                setOperationsPage(page);
                setOperationsTotal(response.meta?.total || 0);
                setHasMoreOperations(response.data.length === 10);
            }
        } catch (err) {
            console.error('Operations history load failed:', err);
        }
        setOperationsLoading(false);
    };

    // Функция загрузки маркетинговой структуры
    const loadMarketingTree = async (telegramId = null) => {
        setMarketingLoading(true);
        try {
            let response;

            if (telegramId) {
                // Используем POST для поиска по telegram_id
                response = await apiCall('/marketing/structure/search', {
                    method: 'POST',
                    body: JSON.stringify({ telegram_id: telegramId })
                });
            } else {
                // Получаем структуру текущего пользователя
                response = await apiCall('/marketing/structure');
            }

            if (response.success) {
                setMarketingTreeData(response.data);
            } else {
                setMarketingTreeData({
                    isActivated: false,
                    message: response.message || 'Программа не активирована'
                });
            }
        } catch (err) {
            console.error('Failed to load marketing structure:', err);
            setMarketingTreeData({
                isActivated: false,
                message: 'Ошибка загрузки структуры: ' + err.message
            });
        }
        setMarketingLoading(false);
    };

    // Функция поиска в маркетинговой структуре
    const handleMarketingSearch = () => {
        if (!marketingSearchId.trim()) {
            if (window.Telegram?.WebApp) {
                window.Telegram.WebApp.showAlert('Пожалуйста, введите ID пользователя');
            } else {
                alert('Пожалуйста, введите ID пользователя');
            }
            return;
        }

        if (!/^\d+$/.test(marketingSearchId)) {
            if (window.Telegram?.WebApp) {
                window.Telegram.WebApp.showAlert('Пожалуйста, введите корректный числовой ID');
            } else {
                alert('Пожалуйста, введите корректный числовой ID');
            }
            return;
        }

        loadMarketingTree(marketingSearchId);
    };

    // Компонент ноды маркетингового дерева
    const MarketingNode = ({ node, onClick, isClickable = true }) => {
        const isEmptyNode = node.id === '?';
        const isReserved = node.active_2 === 0 && node.id !== '?';

        // Определяем клик-функцию в зависимости от уровня
        const handleClick = () => {
            if (!isClickable || isEmptyNode) return;

            // Если это level1 и есть mentor_id, переходим к ментору
            if (node.mentor_id && node.mentor_id !== node.telegram_id) {
                console.log('Переходим к ментору:', node.mentor_id);
                onClick(node.mentor_id);
            } else {
                console.log('Переходим к пользователю:', node.telegram_id);
                onClick(node.telegram_id);
            }
        };

        return (
            <div
                className={`marketing-node ${isClickable && !isEmptyNode ? 'cursor-pointer hover:scale-105' : ''}
                    ${isEmptyNode ? 'empty-node' : ''} transition-all duration-200`}
                onClick={handleClick}
            >
                <div className="avatar">
                    <div className="avatar-placeholder">
                        {isEmptyNode ? '?' : node.id}
                    </div>
                    {node.level && (
                        <div className="avatar-badge">{node.level}</div>
                    )}
                </div>
                <div className="film-effect"></div>

                {isReserved && (
                    <div className="reservation-label">Бронь</div>
                )}

                {node.login && (
                    <a href={`https://t.me/${node.login}`}
                       className="telegram-link"
                       onClick={(e) => e.stopPropagation()}
                       target="_blank"
                       rel="noopener noreferrer"
                    >
                        {node.login}
                    </a>
                )}
            </div>
        );
    };

    const copyReferralLink = () => {
        const link = `https://t.me/concord2025_bot?start=${userData?.id}`;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(link).then(() => {
                if (window.Telegram?.WebApp) {
                    window.Telegram.WebApp.showAlert('Ссылка скопирована!');
                } else {
                    alert('Ссылка скопирована!');
                }
            });
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = link;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            alert('Ссылка скопирована!');
        }
    };

    const exportRewards = async () => {
        try {
            const response = await apiCall('/operations/export', {
                method: 'POST',
                body: JSON.stringify({
                    format: 'csv',
                    date_from: '2024-01-01',
                    date_to: new Date().toISOString().split('T')[0]
                })
            });

            if (response.success) {
                if (window.Telegram?.WebApp) {
                    window.Telegram.WebApp.showAlert('Экспорт готов! Данные подготовлены.');
                } else {
                    alert('Экспорт готов!');
                }
            }
        } catch (err) {
            console.error('Export failed:', err);
            if (window.Telegram?.WebApp) {
                window.Telegram.WebApp.showAlert('Ошибка экспорта: ' + err.message);
            } else {
                alert('Ошибка экспорта: ' + err.message);
            }
        }
    };

    const downloadPresentation = () => {
        const link = document.createElement('a');
        link.href = '/presentation.pdf';
        link.download = 'CONCORD_Presentation.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const openLink = (url) => {
        if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.openLink(url);
        } else {
            window.open(url, '_blank');
        }
    };

    const menuItems = [
        { id: 'home', label: 'Главная', icon: Home },
        { id: 'finances', label: 'Финансы', icon: DollarSign },
        { id: 'partners', label: 'Партнеры', icon: Users },
        { id: 'structure', label: 'Структура', icon: BarChart3 },
        { id: 'marketing', label: 'Маркетинг', icon: TrendingUp },
        { id: 'tools', label: 'Наши Инструменты', icon: Wrench },
        { id: 'presentations', label: 'Презентации', icon: FileText },
        { id: 'documents', label: 'Документы', icon: File },
        { id: 'groups', label: 'Группы и каналы', icon: MessageCircle },
        { id: 'check-generator', label: 'Генератор чеков', icon: FileText },
        // 7. ДОБАВИТЬ В НАВИГАЦИЮ (в массив menuItems):
        {
            id: 'business-card',
            label: 'Моя визитка',
            icon: CreditCard,
            badge: businessCard?.is_active ? 'Активна' : null
        }

    ];

    const tools = [
        {
            id: 'businessCard',
            name: 'Визитка',
            level: 1,
            price: 10,
            description: 'Персональная визитка для привлечения клиентов',
            status: 'В разработке',
            gradient: 'from-emerald-500 to-emerald-600'
        },
        {
            id: 'videoLanding',
            name: 'Видео-лендинг',
            level: 2,
            price: 15,
            description: 'Продающий лендинг с видео презентацией',
            status: 'В разработке',
            gradient: 'from-emerald-600 to-green-600'
        },
        {
            id: 'miniLanding',
            name: 'Мини-лендинг',
            level: 3,
            price: 15,
            description: 'Компактный лендинг для быстрой конверсии',
            status: 'В разработке',
            gradient: 'from-green-600 to-green-700'
        },
        {
            id: 'telegramBot',
            name: 'Телеграм-бот',
            level: 4,
            price: 20,
            description: 'Автоматизированный бот для работы с клиентами',
            status: 'В разработке',
            gradient: 'from-amber-500 to-yellow-600'
        },
        {
            id: 'aiCatalog',
            name: 'Каталог ИИ',
            level: 5,
            price: null,
            description: 'Полный каталог AI инструментов (PDF)',
            status: 'В разработке',
            gradient: 'from-yellow-600 to-amber-600'
        },
        {
            id: 'businessJournal',
            name: 'Бизнесжурнал',
            level: 6,
            price: null,
            description: 'Доступ к бизнес-журналу',
            status: 'В разработке',
            gradient: 'from-amber-600 to-orange-600'
        }
    ];

    const PartnerNode = ({ partner, depth = 0 }) => {
        const hasChildren = partner.count_ref > 0;

        const getLevelColor = (level) => {
            const colors = {
                0: 'bg-gray-500/20 text-white',
                1: 'bg-gray-500/20 text-white',
                2: 'bg-blue-500/20 text-white',
                3: 'bg-green-500/20 text-white',
                4: 'bg-yellow-500/20 text-white',
                5: 'bg-orange-500/20 text-white',
                6: 'bg-red-500/20 text-white'
            };
            return colors[level] || colors[0];
        };

        const handleViewTeam = async () => {
            try {
                setNavigationStack(prev => [...prev, {
                    userId: currentUserId,
                    userInfo: currentUserInfo,
                    structure: partnersStructure
                }]);

                const response = await apiCall(`/user/partners?user_id=${partner.id}`);
                if (response.success) {
                    setPartnersStructure(response.data.teams || []);
                    setCurrentUserId(partner.id);
                    setCurrentUserInfo(response.data.info);

                    if (window.Telegram?.WebApp) {
                        window.Telegram.WebApp.showAlert(`Загружена команда партнера: ${partner.name || partner.full_name || `${partner.first_name} ${partner.last_name}`.trim()}`);
                    }
                }
            } catch (err) {
                console.error('Failed to load partner team:', err);
                if (window.Telegram?.WebApp) {
                    window.Telegram.WebApp.showAlert('Ошибка загрузки команды: ' + err.message);
                }
            }
        };

        return (
            <div className={`${depth > 0 ? 'ml-2 md:ml-6 border-l border-white/10 pl-2 md:pl-4' : ''}`}>
                <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-3 md:p-4 mb-3">
                    {/* Мобильная версия */}
                    <div className="block md:hidden">
                        <div className="flex items-start gap-3">
                            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center flex-shrink-0">
                                <User className="text-white" size={16} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-white font-medium text-sm truncate">
                                    {partner.name || partner.full_name || `${partner.first_name} ${partner.last_name}`.trim() || `Партнер #${partner.id}`}
                                </div>
                                <div className="text-white text-xs">
                                    {new Date(partner.joined_at || partner.created_at).toLocaleDateString('ru-RU')}
                                </div>
                                <div className="flex items-center gap-2 mt-1">
                                    <div className={`px-2 py-1 rounded-full text-xs font-semibold ${getLevelColor(partner.level || partner.user_level || 0)}`}>
                                        Ур.{partner.level || partner.user_level || 0}
                                    </div>
                                    {partner.active && (
                                        <div className="w-2 h-2 bg-green-400 rounded-full" title="Активен"></div>
                                    )}
                                </div>
                            </div>
                            <div className="text-right flex-shrink-0">
                                <div className="text-emerald-400 font-semibold text-sm">
                                    ${(partner.total_earnings || 0).toFixed(0)}
                                </div>
                                <div className="text-white text-xs">доход</div>
                            </div>
                        </div>

                        {partner.count_ref > 0 && (
                            <div className="mt-2 flex items-center justify-between">
                                <div className="text-blue-400 text-xs">
                                    Команда: {partner.count_ref} чел.
                                </div>
                                <button
                                    onClick={handleViewTeam}
                                    className="text-xs bg-blue-500/20 hover:bg-blue-500/30 text-white px-2 py-1 rounded-lg transition-colors flex items-center gap-1"
                                >
                                    <Eye size={12} />
                                    Смотреть
                                </button>
                            </div>
                        )}

                        {partner.position_name && (
                            <div className="mt-2 flex flex-wrap gap-1">
                               <span className="text-xs px-2 py-1 bg-purple-500/20 text-white rounded-full">
                                   {partner.position_name}
                               </span>
                                {partner.program_name && (
                                    <span className="text-xs px-2 py-1 bg-blue-500/20 text-white rounded-full">
                                       {partner.program_name}
                                   </span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const ToolCard = ({ tool }) => {
        const userLevel = userData?.user_level || 0;
        const hasAccess = userLevel >= tool.level && userLevel > 0;

        return (
            <div className="relative group">
                <div className={`relative overflow-hidden rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-6 transition-all duration-300 hover:scale-105 hover:bg-white/15 ${!hasAccess ? 'opacity-60' : ''}`}>
                    <div className={`absolute top-0 left-0 w-full h-2 bg-gradient-to-r ${tool.gradient}`}></div>

                    <div className="absolute top-4 right-4">
                        <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${hasAccess ? 'bg-emerald-500/20 text-white' : 'bg-gray-500/20 text-white'}`}>
                            <Crown size={12} />
                            Ур.{tool.level}
                        </div>
                    </div>

                    <div className="absolute top-4 left-4">
                        <div className="flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-orange-500/20 text-white">
                            <Construction size={12} />
                            {tool.status}
                        </div>
                    </div>

                    <div className="mt-8">
                        <h3 className="text-xl font-bold text-white mb-2">{tool.name}</h3>
                        <p className="text-white text-sm mb-4">{tool.description}</p>

                        {hasAccess ? (
                            <div className="space-y-3">
                                <button className="w-full bg-gray-500/20 text-white py-2 px-4 rounded-lg cursor-not-allowed flex items-center justify-center gap-2">
                                    <Construction size={16} />
                                    В разработке
                                </button>
                            </div>
                        ) : (
                            <div className="flex items-center gap-2 text-white text-sm">
                                <Lock size={16} />
                                {userLevel === 0
                                    ? 'Требуется участие в программе'
                                    : `Требуется уровень ${tool.level}`
                                }
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    // Функция фильтрации операций
    const filterOperations = async () => {
        setOperationsPage(1);
        await loadOperationsHistory(1, true);
    };

    // Функция загрузки следующей страницы операций
    const loadMoreOperations = async () => {
        if (!operationsLoading && hasMoreOperations) {
            await loadOperationsHistory(operationsPage + 1, false);
        }
    };

    // Получить иконку для типа операции
    const getOperationIcon = (type) => {
        switch(type) {
            case 1: return TrendingUp; // Перевод за уровень
            case 2: return TrendingDown; // Списание
            case 3: return Gift; // Вознаграждение
            case 4:
            case 5: return ArrowUpCircle; // Перевод
            case 6: return ArrowUpCircle; // Вывод
            default: return AlertCircle;
        }
    };

    // Получить цвет для типа операции
    const getOperationColor = (type, status) => {
        if (status === 2) return 'text-red-400 bg-red-500/20'; // Отменена
        if (status === 0) return 'text-yellow-400 bg-yellow-500/20'; // В обработке

        switch(type) {
            case 1: return 'text-blue-400 bg-blue-500/20';
            case 2: return 'text-red-400 bg-red-500/20';
            case 3: return 'text-emerald-400 bg-emerald-500/20';
            case 4:
            case 5: return 'text-purple-400 bg-purple-500/20';
            case 6: return 'text-orange-400 bg-orange-500/20';
            default: return 'text-gray-400 bg-gray-500/20';
        }
    };

    // Рендер маркетингового контента (теперь это только картинка)
    const renderMarketingContent = () => {
        return (
            <div className="space-y-6">
                <h2 className="text-2xl font-bold text-white mb-6">Маркетинг</h2>

                <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                    <img
                        src="/table.jpg"
                        alt="CONCORD Маркетинг"
                        className="w-full h-auto cursor-pointer transition-transform hover:scale-105 rounded-lg"
                        onClick={() => {
                            // Создаем модальное окно для увеличенного просмотра
                            const modal = document.createElement('div');
                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                            modal.onclick = () => modal.remove();

                            const container = document.createElement('div');
                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                            container.onclick = (e) => e.stopPropagation();

                            const img = document.createElement('img');
                            img.src = '/table.jpg';
                            img.className = 'w-full h-auto object-contain';

                            const closeBtn = document.createElement('button');
                            closeBtn.innerHTML = '✕';
                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                            closeBtn.onclick = () => modal.remove();

                            container.appendChild(img);
                            container.appendChild(closeBtn);
                            modal.appendChild(container);
                            document.body.appendChild(modal);
                        }}
                    />
                    <p className="text-center text-white mt-4 text-sm">
                        Нажмите на изображение для увеличения
                    </p>
                </div>
            </div>
        );
    };

    // Рендер контента структуры (маркетинговое дерево)
    const renderStructureContent = () => {
        if (marketingLoading) {
            return (
                <div className="flex items-center justify-center h-64">
                    <div className="flex items-center gap-3 text-white">
                        <Loader2 className="animate-spin" size={24} />
                        <span>Загрузка маркетинговой структуры...</span>
                    </div>
                </div>
            );
        }

        if (marketingTreeData && !marketingTreeData.isActivated) {
            return (
                <div className="activation-message">
                    <div className="message-icon">⚠️</div>
                    <h2 className="message-title">
                        <span className="shimmer">CONCORD</span>
                    </h2>
                    <p className="message-content">
                        {marketingTreeData.message || 'Вы еще не активировали данную программу'}
                    </p>
                    <button
                        onClick={() => loadMarketingTree()}
                        className="retry-button"
                    >
                        Обновить
                    </button>
                </div>
            );
        }

        return (
            <div className="space-y-6">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-white">Структура</h2>
                    <button
                        onClick={() => loadMarketingTree()}
                        className="p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white hover:text-white transition-colors"
                        title="Обновить структуру"
                    >
                        <RefreshCw size={16} />
                    </button>
                </div>

                {/* Поиск по ID */}
                <div className="search-container">
                    <div className="search-wrapper">
                        <input
                            type="text"
                            value={marketingSearchId}
                            onChange={(e) => setMarketingSearchId(e.target.value)}
                            className="search-input"
                            placeholder="Введите ID пользователя"
                            onKeyPress={(e) => e.key === 'Enter' && handleMarketingSearch()}
                        />
                        <button
                            onClick={handleMarketingSearch}
                            className="search-button"
                        >
                            <Search size={16} />
                        </button>
                    </div>
                </div>

                {/* Маркетинговое дерево */}
                <div className="marketing-tree">
                    {/* Уровень 1 */}
                    <div className="level level-1">
                        {marketingTreeData?.level1 && (
                            <MarketingNode
                                node={marketingTreeData.level1}
                                onClick={loadMarketingTree}
                            />
                        )}
                    </div>

                    {/* Коннектор */}
                    <div className="connector"></div>
                    <div className="horizontal-connector level-1-2-connector">
                        <div className="h-line"></div>
                    </div>
                    <div className="level-1-vertical-connectors">
                        <div className="level-1-v-connectors-group">
                            <div className="level-1-v-connector"></div>
                            <div className="level-1-v-connector"></div>
                            <div className="level-1-v-connector"></div>
                        </div>
                    </div>

                    {/* Уровень 2 */}
                    <div className="level level-2">
                        {marketingTreeData?.level2?.map((node, index) => (
                            <MarketingNode
                                key={index}
                                node={node}
                                onClick={loadMarketingTree}
                            />
                        ))}
                    </div>

                    {/* Коннектор между уровнем 2 и 3 */}
                    <div className="horizontal-connector level-2-3-connector">
                        <div className="h-line"></div>
                    </div>
                    <div className="v-connectors">
                        {Array.from({length: 9}, (_, i) => (
                            <div key={i} className="v-connector"></div>
                        ))}
                    </div>

                    {/* Уровень 3 - в одну строку */}
                    <div className="level-3-container">
                        <div className="level level-3">
                            {marketingTreeData?.level3?.map((node, index) => (
                                <MarketingNode
                                    key={index}
                                    node={node}
                                    onClick={loadMarketingTree}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderContent = () => {
        if (loading) {
            return (
                <div className="flex items-center justify-center h-64">
                    <div className="flex items-center gap-3 text-white">
                        <Loader2 className="animate-spin" size={24} />
                        <span>Загрузка данных...</span>
                    </div>
                </div>
            );
        }

        if (error && !userData) {
            return (
                <div className="flex items-center justify-center h-64">
                    <div className="text-center">
                        <AlertCircle className="text-red-400 mx-auto mb-4" size={48} />
                        <h3 className="text-white text-xl mb-2">Ошибка загрузки</h3>
                        <p className="text-white mb-4">{error}</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 mx-auto"
                        >
                            <RefreshCw size={16} />
                            Попробовать снова
                        </button>
                    </div>
                </div>
            );
        }

        // Обновленный renderContent для страницы finances
        const renderFinancesContent = () => {
            return (
                <div className="space-y-6">
                    <div className="flex items-center justify-between">
                        <h2 className="text-2xl font-bold text-white">Финансы</h2>
                        <div className="text-right">
                            <div className="text-sm text-white">Общий доход</div>
                            <div className="text-2xl font-bold text-emerald-400">
                                ${userData?.balance?.toFixed(2) || '0.00'}
                            </div>
                        </div>
                    </div>

                    {/* Статистика */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                            <div className="flex items-center gap-2 mb-2">
                                <Gift className="text-emerald-400" size={20} />
                                <span className="text-white text-sm font-medium">Сегодня</span>
                            </div>
                            <div className="text-xl font-bold text-emerald-400">
                                ${operationsStats?.today?.toFixed(2) || '0.00'}
                            </div>
                        </div>

                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                            <div className="flex items-center gap-2 mb-2">
                                <Calendar className="text-blue-400" size={20} />
                                <span className="text-white text-sm font-medium">Этот месяц</span>
                            </div>
                            <div className="text-xl font-bold text-blue-400">
                                ${operationsStats?.this_month?.toFixed(2) || '0.00'}
                            </div>
                        </div>

                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                            <div className="flex items-center gap-2 mb-2">
                                <BarChart3 className="text-purple-400" size={20} />
                                <span className="text-white text-sm font-medium">Операций</span>
                            </div>
                            <div className="text-xl font-bold text-purple-400">
                                {operationsStats?.operations_count || 0}
                            </div>
                        </div>

                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                            <div className="flex items-center gap-2 mb-2">
                                <TrendingUp className="text-yellow-400" size={20} />
                                <span className="text-white text-sm font-medium">Средний</span>
                            </div>
                            <div className="text-xl font-bold text-yellow-400">
                                ${operationsStats?.avg_earning?.toFixed(2) || '0.00'}
                            </div>
                        </div>
                    </div>

                    {/* Фильтры операций */}
                    <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                        <h3 className="text-lg font-semibold text-white mb-4">Фильтры</h3>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div>
                                <label className="block text-sm text-white mb-2">Тип операции</label>
                                <select
                                    value={operationsFilter.type}
                                    onChange={(e) => setOperationsFilter(prev => ({...prev, type: e.target.value}))}
                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white text-sm"
                                >
                                    <option value="all">Все типы</option>
                                    <option value="1">Перевод за уровень</option>
                                    <option value="2">Списание</option>
                                    <option value="3">Вознаграждение</option>
                                    <option value="4">Перевод</option>
                                    <option value="5">Перевод</option>
                                    <option value="6">Вывод</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm text-white mb-2">Статус</label>
                                <select
                                    value={operationsFilter.status}
                                    onChange={(e) => setOperationsFilter(prev => ({...prev, status: e.target.value}))}
                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white text-sm"
                                >
                                    <option value="all">Все статусы</option>
                                    <option value="0">В обработке</option>
                                    <option value="1">Выполнена</option>
                                    <option value="2">Отменена</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm text-white mb-2">Дата с</label>
                                <input
                                    type="date"
                                    value={operationsFilter.date_from}
                                    onChange={(e) => setOperationsFilter(prev => ({...prev, date_from: e.target.value}))}
                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white text-sm"
                                />
                            </div>

                            <div>
                                <label className="block text-sm text-white mb-2">Дата до</label>
                                <input
                                    type="date"
                                    value={operationsFilter.date_to}
                                    onChange={(e) => setOperationsFilter(prev => ({...prev, date_to: e.target.value}))}
                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-white text-sm"
                                />
                            </div>
                        </div>

                        <div className="flex gap-2 mt-4">
                            <button
                                onClick={filterOperations}
                                className="bg-blue-500/20 hover:bg-blue-500/30 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2"
                            >
                                <Eye size={16} />
                                Применить фильтр
                            </button>
                            <button
                                onClick={() => {
                                    setOperationsFilter({
                                        type: 'all',
                                        status: 'all',
                                        date_from: '',
                                        date_to: ''
                                    });
                                    setOperationsPage(1);
                                    loadOperationsHistory(1, true);
                                }}
                                className="bg-gray-500/20 hover:bg-gray-500/30 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2"
                            >
                                <RefreshCw size={16} />
                                Сбросить
                            </button>
                        </div>
                    </div>

                    {/* История операций */}
                    <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                        <div className="flex items-center justify-between mb-6">
                            <h3 className="text-xl font-semibold text-white">История операций</h3>
                            <button
                                onClick={exportRewards}
                                className="bg-emerald-500/20 hover:bg-emerald-500/30 text-white px-4 py-2 rounded-lg transition-colors flex items-center gap-2"
                            >
                                <Download size={16} />
                                Экспорт
                            </button>
                        </div>

                        <div className="space-y-4">
                            {operationsHistory.map((operation) => {
                                const IconComponent = getOperationIcon(operation.type);
                                const colorClasses = getOperationColor(operation.type, operation.status);

                                return (
                                    <div key={operation.id} className="bg-white/5 rounded-xl p-4 border border-white/10">
                                        {/* Мобильная версия */}
                                        <div className="block md:hidden">
                                            <div className="flex items-start gap-3">
                                                <div className={`p-2 rounded-lg ${colorClasses}`}>
                                                    <IconComponent size={20} />
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-start justify-between">
                                                        <div>
                                                            <div className="text-white font-medium text-sm">
                                                                {operation.type_name}
                                                            </div>
                                                            <div className="text-white text-xs">
                                                                {operation.formatted_date}
                                                            </div>
                                                            <div className="text-white text-xs">
                                                                {operation.receiver_login}
                                                            </div>
                                                        </div>
                                                        <div className="text-right">
                                                            <div className={`font-semibold text-lg ${
                                                                operation.type === 2 ? 'text-red-400' : 'text-emerald-400'
                                                            }`}>
                                                                {operation.type === 2 ? '-' : '+'}${Number(operation.display_amount || 0).toFixed(2)}
                                                            </div>
                                                            <div className={`text-xs px-2 py-1 rounded-full ${
                                                                operation.status === 1 ? 'bg-green-500/20 text-white' :
                                                                    operation.status === 0 ? 'bg-yellow-500/20 text-white' :
                                                                        'bg-red-500/20 text-white'
                                                            }`}>
                                                                {operation.status_name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {operation.comment && (
                                                        <div className="mt-2 text-sm text-white bg-white/5 rounded p-2">
                                                            {operation.comment}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Десктопная версия */}
                                        <div className="hidden md:block">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-4">
                                                    <div className={`p-3 rounded-lg ${colorClasses}`}>
                                                        <IconComponent size={24} />
                                                    </div>
                                                    <div>
                                                        <div className="text-white font-medium">{operation.type_name}</div>
                                                        <div className="text-white text-sm">{operation.formatted_date}</div>
                                                        <div className="text-white text-sm">Получатель: {operation.receiver_login}</div>
                                                        {operation.comment && (
                                                            <div className="text-white text-sm mt-1 max-w-md truncate">
                                                                {operation.comment}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="text-right">
                                                    <div className={`font-semibold text-xl ${
                                                        operation.type === 2 ? 'text-red-400' : 'text-emerald-400'
                                                    }`}>
                                                        {operation.type === 2 ? '-' : '+'}${Number(operation.display_amount || 0).toFixed(2)}
                                                    </div>
                                                    <div className={`text-sm px-3 py-1 rounded-full inline-block ${
                                                        operation.status === 1 ? 'bg-green-500/20 text-white' :
                                                            operation.status === 0 ? 'bg-yellow-500/20 text-white' :
                                                                'bg-red-500/20 text-white'
                                                    }`}>
                                                        {operation.status_name}
                                                    </div>
                                                    {operation.amount !== operation.display_amount && (
                                                        <div className="text-xs text-white mt-1">
                                                            БД: ${Number(operation.amount || 0).toFixed(2)}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {operationsHistory.length === 0 && !operationsLoading && (
                                <div className="text-center py-8 text-white">
                                    <Clock className="mx-auto mb-4 text-gray-500" size={48} />
                                    <p>История операций пока пуста</p>
                                </div>
                            )}

                            {/* Кнопка "Загрузить еще" */}
                            {hasMoreOperations && operationsHistory.length > 0 && (
                                <div className="text-center pt-4">
                                    <button
                                        onClick={loadMoreOperations}
                                        disabled={operationsLoading}
                                        className="bg-blue-500/20 hover:bg-blue-500/30 text-white px-6 py-2 rounded-lg transition-colors flex items-center gap-2 mx-auto disabled:opacity-50"
                                    >
                                        {operationsLoading ? (
                                            <>
                                                <Loader2 className="animate-spin" size={16} />
                                                Загрузка...
                                            </>
                                        ) : (
                                            <>
                                                <ChevronDown size={16} />
                                                Загрузить еще
                                            </>
                                        )}
                                    </button>
                                </div>
                            )}

                            {operationsLoading && operationsHistory.length === 0 && (
                                <div className="text-center py-8">
                                    <Loader2 className="animate-spin mx-auto mb-4 text-blue-400" size={32} />
                                    <p className="text-white">Загрузка операций...</p>
                                </div>
                            )}
                        </div>

                        {/* Информация о пагинации */}
                        {operationsTotal > 0 && (
                            <div className="mt-4 text-center text-sm text-white">
                                Показано {operationsHistory.length} из {operationsTotal} операций
                            </div>
                        )}
                    </div>

                    {/* Заявки на вывод */}
                    {withdrawalRequests.length > 0 && (
                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                            <h3 className="text-xl font-semibold text-white mb-4">Заявки на вывод</h3>
                            <div className="space-y-3">
                                {withdrawalRequests.slice(0, 3).map((request) => (
                                    <div key={request.id} className="bg-white/5 rounded-lg p-3 border border-white/10">
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-3">
                                                <ArrowUpCircle className="text-orange-400" size={16} />
                                                <div>
                                                    <div className="text-white text-sm font-medium">${request.amount}</div>
                                                    <div className="text-white text-xs">{request.formatted_date}</div>
                                                </div>
                                            </div>
                                            <div className={`px-2 py-1 rounded-full text-xs font-semibold ${
                                                request.status === 'Выполнено' ? 'bg-green-500/20 text-white' :
                                                    request.status === 'В ожидании' ? 'bg-yellow-500/20 text-white' :
                                                        'bg-gray-500/20 text-white'
                                            }`}>
                                                {request.status}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            );
        };
        switch (activeTab) {
            case 'home':
                return (
                    <div className="space-y-8">
                        <div className="text-center">
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-green-500/20 border border-emerald-500/30 mb-6">
                                <Zap className="text-emerald-400" size={20} />
                                <span className="text-emerald-300 font-semibold">БЕСКОНЕЧНЫЙ ДОХОД</span>
                            </div>
                            <h1 className="text-4xl font-bold text-white mb-4 bg-gradient-to-r from-white to-green-100 bg-clip-text text-transparent">
                                Добро пожаловать в CONCORD
                            </h1>
                            <p className="text-green-100 text-lg max-w-2xl mx-auto">
                                Ваша платформа для создания активного дохода через современные инструменты маркетинга и партнерства
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Общий доход */}
                            <div
                                className="bg-gradient-to-r from-emerald-500/10 to-green-500/10 border border-emerald-500/20 rounded-2xl p-6">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="p-3 rounded-xl bg-emerald-500/20">
                                        <DollarSign className="text-emerald-400" size={28}/>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold text-lg">Общий доход</h3>
                                        <p className="text-green-200 text-sm">Все вознаграждения</p>
                                    </div>
                                </div>
                                <div className="text-3xl font-bold ny-gold mb-2">
                                    ${userData?.balance?.toFixed(2) || '0.00'}
                                </div>
                                <div className="text-green-300 text-sm">
                                    За все время участия в проекте
                                </div>
                            </div>

                            {/* Численность команды */}
                            <div
                                className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 rounded-2xl p-6">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="p-3 rounded-xl bg-blue-500/20">
                                        <Users className="text-blue-400" size={28}/>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold text-lg">Численность команды</h3>
                                        <p className="text-blue-200 text-sm">Общая структура</p>
                                    </div>
                                </div>
                                <div className="text-3xl font-bold text-blue-400 mb-2">
                                    {userData?.team_stats?.total_structure || partnersStructure.length}
                                </div>
                                <div className="text-blue-300 text-sm space-y-1">
                                    <div>Прямых рефералов: {userData?.team_stats?.direct_referrals || userData?.active_referrals_count || 0}</div>
                                    <div>Активных в маркетинге: {userData?.team_stats?.active_in_marketing || 0}</div>
                                </div>
                            </div>
                        </div>

                        {/* Дополнительная статистика */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="p-2 rounded-lg bg-yellow-500/20">
                                        <Crown className="text-yellow-400" size={24}/>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold">Ваш уровень</h3>
                                        <p className="text-yellow-200 text-sm">
                                            {userData?.user_level === 0 ? 'Не участвует в программе' : 'Текущий статус'}
                                        </p>
                                    </div>
                                </div>
                                <div className="text-2xl font-bold text-yellow-400">
                                    {userData?.user_level === 0 ? 'Уровень 0' : `Уровень ${userData?.user_level || 0}`}
                                </div>
                                {userData?.user_level === 0 && (
                                    <div className="mt-2 text-sm text-white">
                                        Обратитесь к администратору для добавления в маркетинговую программу
                                    </div>
                                )}
                            </div>

                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="p-2 rounded-lg bg-purple-500/20">
                                        <Calendar className="text-purple-400" size={24}/>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold">В проекте</h3>
                                        <p className="text-purple-200 text-sm">Дата регистрации</p>
                                    </div>
                                </div>
                                <div className="text-lg font-bold text-purple-400">
                                    {userData?.created_at ? new Date(userData.created_at).toLocaleDateString('ru-RU') : 'Неизвестно'}
                                </div>
                            </div>

                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="p-2 rounded-lg bg-green-500/20">
                                        <User className="text-green-400" size={24}/>
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold">Профиль</h3>
                                        <p className="text-green-200 text-sm">Личная информация</p>
                                    </div>
                                </div>
                                <div className="text-sm font-medium text-green-400">
                                    {userData?.full_name || userData?.first_name || 'Пользователь'}
                                </div>
                                <div className="text-xs text-green-300">
                                    @{userData?.login || 'username'}
                                </div>
                            </div>
                        </div>

                        {/* Реферальная ссылка */}
                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                            <h3 className="text-xl font-semibold text-white mb-4">Ваша реферальная ссылка</h3>
                            <div className="bg-white/5 rounded-lg p-4">
                                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                    <code className="text-emerald-400 text-sm flex-1 break-all min-w-0">
                                        https://t.me/concord2025_bot?start={userData?.id || '12345'}
                                    </code>
                                    <button
                                        onClick={copyReferralLink}
                                        className="bg-emerald-500/20 hover:bg-emerald-500/30 text-white p-2 rounded-lg transition-colors flex items-center gap-2 flex-shrink-0"
                                    >
                                        <Copy size={16}/>
                                        Копировать
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 'check-generator':
                return (
                    <div className="space-y-6">
                        <div className="flex items-center justify-between">
                            <h2 className="text-2xl font-bold text-white">Генератор чеков</h2>
                            <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-500/30">
                                <CheckCircle className="text-emerald-400" size={16} />
                                <span className="text-white text-sm font-medium">Автоотправка в Telegram</span>
                            </div>
                        </div>

                        <div className="bg-gradient-to-r from-emerald-500/10 to-green-500/10 border border-emerald-500/20 rounded-2xl p-6">
                            <div className="flex items-start gap-3">
                                <FileText className="text-emerald-400 mt-1" size={24} />
                                <div>
                                    <h3 className="text-white font-semibold mb-2">Как это работает</h3>
                                    <ul className="text-white text-sm space-y-1">
                                        <li>• Заполните форму или используйте быструю генерацию</li>
                                        <li>• Чек автоматически сгенерируется</li>
                                        <li>• Вы получите его в Telegram-боте</li>
                                        <li>• Также сможете скачать или поделиться им здесь</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            {/* Форма генерации */}
                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <h3 className="text-xl font-semibold text-white mb-4">Создать чек</h3>

                                <form onSubmit={async (e) => {
                                    e.preventDefault();
                                    setCheckGenerating(true);

                                    const formData = new FormData(e.target);
                                    formData.append('telegram_id', userData.telegram_id);
                                    formData.append('custom_id', e.target.custom_id.value || '');
                                    try {
                                        const response = await fetch(`${API_BASE}/check-generator/generate`, {
                                            method: 'POST',
                                            headers: {
                                                'Authorization': `Bearer ${token}`
                                            },
                                            body: formData
                                        });

                                        const data = await response.json();

                                        if (data.success) {
                                            setGeneratedCheck(data.data.image_url);

                                            const message = data.data.telegram_sent
                                                ? 'Чек сгенерирован и отправлен вам в Telegram!'
                                                : 'Чек сгенерирован, но не удалось отправить в Telegram';

                                            if (window.Telegram?.WebApp) {
                                                window.Telegram.WebApp.showAlert(message);
                                            } else {
                                                alert(message);
                                            }
                                        } else {
                                            throw new Error(data.message);
                                        }
                                    } catch (err) {
                                        console.error('Check generation failed:', err);
                                        const errorMsg = 'Ошибка генерации: ' + err.message;
                                        if (window.Telegram?.WebApp) {
                                            window.Telegram.WebApp.showAlert(errorMsg);
                                        } else {
                                            alert(errorMsg);
                                        }
                                    } finally {
                                        setCheckGenerating(false);
                                    }
                                }} className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-white mb-2">
                                            ID (необязательно)
                                        </label>
                                        <input
                                            type="text"
                                            name="custom_id"
                                            maxLength="50"
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-white focus:outline-none focus:border-emerald-500"
                                            placeholder="Оставьте пустым для 'CONCORD'"
                                        />
                                        <p className="text-xs text-white mt-1">
                                            Будет отображаться как "ID: ваш текст"
                                        </p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-white mb-2">
                                            Имя
                                        </label>
                                        <input
                                            type="text"
                                            name="first_name"
                                            defaultValue={userData?.first_name || ''}
                                            required
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-white focus:outline-none focus:border-emerald-500"
                                            placeholder="Введите имя"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-white mb-2">
                                            Фамилия
                                        </label>
                                        <input
                                            type="text"
                                            name="last_name"
                                            defaultValue={userData?.last_name || ''}
                                            required
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-white focus:outline-none focus:border-emerald-500"
                                            placeholder="Введите фамилию"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-white mb-2">
                                            Сумма ($)
                                        </label>
                                        <input
                                            type="number"
                                            name="amount"
                                            defaultValue={userData?.balance || 0}
                                            min="0"
                                            step="0.01"
                                            required
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-white focus:outline-none focus:border-emerald-500"
                                            placeholder="0.00"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-white mb-2">
                                            Фото (необязательно)
                                        </label>
                                        <input
                                            type="file"
                                            name="photo"
                                            accept="image/jpeg,image/jpg,image/png,image/gif"
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-emerald-500/20 file:text-white hover:file:bg-emerald-500/30 file:cursor-pointer"
                                        />
                                        <p className="text-xs text-white mt-1">
                                            Максимальный размер: 5MB. Форматы: JPG, PNG, GIF
                                        </p>
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={checkGenerating}
                                        className="w-full bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {checkGenerating ? (
                                            <>
                                                <Loader2 className="animate-spin" size={20}/>
                                                Генерация...
                                            </>
                                        ) : (
                                            <>
                                                <FileText size={20}/>
                                                Сгенерировать и отправить
                                            </>
                                        )}
                                    </button>
                                </form>

                                {/* Быстрая генерация для себя */}
                                <div className="mt-6 pt-6 border-t border-white/10">
                                    <h4 className="text-white font-medium mb-3">Быстрая генерация</h4>
                                    <button
                                        onClick={async () => {
                                            setCheckGenerating(true);
                                            try {
                                                const response = await apiCall('/check-generator/generate-me', {
                                                    method: 'POST'
                                                });

                                                if (response.success) {
                                                    setGeneratedCheck(response.data.image_url);

                                                    const message = response.data.telegram_sent
                                                        ? 'Ваш чек отправлен в Telegram!'
                                                        : 'Чек готов, но не удалось отправить в Telegram';

                                                    if (window.Telegram?.WebApp) {
                                                        window.Telegram.WebApp.showAlert(message);
                                                    } else {
                                                        alert(message);
                                                    }
                                                }
                                            } catch (err) {
                                                console.error('Quick check generation failed:', err);
                                                if (window.Telegram?.WebApp) {
                                                    window.Telegram.WebApp.showAlert('Ошибка: ' + err.message);
                                                } else {
                                                    alert('Ошибка: ' + err.message);
                                                }
                                            } finally {
                                                setCheckGenerating(false);
                                            }
                                        }}
                                        disabled={checkGenerating}
                                        className="w-full bg-blue-500/20 hover:bg-blue-500/30 text-white py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {checkGenerating ? (
                                            <>
                                                <Loader2 className="animate-spin" size={16} />
                                                Генерация...
                                            </>
                                        ) : (
                                            <>
                                                <Zap size={16} />
                                                Мой чек с текущим балансом
                                            </>
                                        )}
                                    </button>
                                    <p className="text-xs text-white mt-2 text-center">
                                        Использует ваши данные и текущий баланс
                                    </p>
                                </div>
                            </div>

                            {/* Превью сгенерированного чека */}
                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <h3 className="text-xl font-semibold text-white mb-4">Результат</h3>

                                {generatedCheck ? (
                                        <div className="space-y-4">
                                            <div className="relative group">
                                                <img
                                                    src={generatedCheck}
                                                    alt="Сгенерированный чек"
                                                    className="w-full h-auto rounded-lg border-2 border-emerald-500/30 cursor-pointer transition-transform hover:scale-105"
                                                    onClick={() => {
                                                        // Открыть в полном размере
                                                        const modal = document.createElement('div');
                                                        modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                                        modal.onclick = () => modal.remove();

                                                        const container = document.createElement('div');
                                                        container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                                        container.onclick = (e) => e.stopPropagation();

                                                        const img = document.createElement('img');
                                                        img.src = generatedCheck;
                                                        img.className = 'w-full h-auto object-contain';

                                                        const closeBtn = document.createElement('button');
                                                        closeBtn.innerHTML = '✕';
                                                        closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                                        closeBtn.onclick = () => modal.remove();

                                                        container.appendChild(img);
                                                        container.appendChild(closeBtn);
                                                        modal.appendChild(container);
                                                        document.body.appendChild(modal);
                                                    }}
                                                />
                                                <div className="absolute top-2 right-2 bg-emerald-500/90 text-white px-3 py-1 rounded-full text-xs font-semibold">
                                                    Отправлено в Telegram
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-2">

                                            <a    href={generatedCheck}
                                                download
                                                className="bg-emerald-500/20 hover:bg-emerald-500/30 text-white py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                                                >
                                                <Download size={16} />
                                                Скачать
                                            </a>
                                            <button
                                                onClick={() => {
                                                    if (navigator.share) {
                                                        navigator.share({
                                                            title: 'CONCORD Чек',
                                                            text: 'Мой чек из CONCORD',
                                                            url: generatedCheck
                                                        }).catch(err => console.log('Share failed:', err));
                                                    } else {
                                                        window.open(generatedCheck, '_blank');
                                                    }
                                                }}
                                                className="bg-blue-500/20 hover:bg-blue-500/30 text-white py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                                            >
                                                <ExternalLink size={16} />
                                                Поделиться
                                            </button>
                                        </div>

                                    <button
                                        onClick={() => setGeneratedCheck(null)}
                                        className="w-full bg-gray-500/20 hover:bg-gray-500/30 text-white py-2 px-4 rounded-lg transition-colors text-sm"
                                    >
                                        Создать новый чек
                                    </button>
                                    </div>
                                    ) : (
                                    <div className="text-center py-12">
                                    <FileText className="mx-auto mb-4 text-gray-500" size={48} />
                            <p className="text-white mb-2">
                                Заполните форму и нажмите кнопку генерации
                            </p>
                            <p className="text-white text-sm">
                                Чек будет автоматически отправлен вам в Telegram
                            </p>
                        </div>
                        )}
                    </div>
            </div>

            {/* Информационный блок */}
                <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                    <h3 className="text-lg font-semibold text-white mb-4">Примеры использования</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="bg-white/5 rounded-lg p-4">
                            <div className="text-emerald-400 font-semibold mb-2">Для партнеров</div>
                            <p className="text-white text-sm">
                                Делитесь чеками с достижениями для мотивации команды
                            </p>
                        </div>
                        <div className="bg-white/5 rounded-lg p-4">
                            <div className="text-blue-400 font-semibold mb-2">В социальных сетях</div>
                            <p className="text-white text-sm">
                                Публикуйте успехи для привлечения новых партнеров
                            </p>
                        </div>
                        <div className="bg-white/5 rounded-lg p-4">
                            <div className="text-purple-400 font-semibold mb-2">Личный архив</div>
                            <p className="text-white text-sm">
                                Сохраняйте чеки как подтверждение результатов
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            );
            // 8. ДОБАВИТЬ В РЕНДЕР (в switch case для activeTab):
            case 'business-card':
                if (showCardEditor) {
                    return <BusinessCardEditor
                        cardForm={cardForm}
                        setCardForm={setCardForm}
                        cardLoading={cardLoading}
                        saveBusinessCard={saveBusinessCard}
                        businessCard={null}
                        toggleCardActive={() => {}}
                        shareBusinessCard={() => shareCard(cardForm)}
                        setActiveTab={() => setShowCardEditor(false)}
                        isNewCard={!currentCardId}
                    />;
                } else {
                    return <BusinessCardsList
                        cards={businessCards}
                        loading={cardsLoading}
                        onCreateNew={createNewCard}
                        onEdit={(card) => loadCardForEdit(card.id)}
                        onDelete={deleteCard}
                        onToggleActive={toggleCardActive}
                        onSetDefault={setCardAsDefault}
                        onShare={shareCard}
                        onRefresh={loadBusinessCards}
                    />;
                }
            case 'finances':
                return renderFinancesContent();

            case 'partners':
                return (
                    <div className="space-y-6">
                        <div className="flex items-center justify-between">
                            <h2 className="text-2xl font-bold text-white">Партнеры</h2>
                            <div className="flex items-center gap-4">
                                <button
                                    onClick={loadDashboardData}
                                    className="p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white hover:text-white transition-colors"
                                    title="Обновить данные"
                                >
                                    <RefreshCw size={16} />
                                </button>
                                <div className="text-right">
                                    <div className="text-sm text-white">Общая структура</div>
                                    <div className="text-xl font-bold text-blue-400">
                                        {userData?.team_stats?.total_structure || partnersStructure.length} партнеров
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Навигация по структуре */}
                        {(currentUserId !== userData?.id || navigationStack.length > 0) && (
                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                                            <User className="text-white" size={16} />
                                        </div>
                                        <div>
                                            <div className="text-white font-medium">
                                                Команда: {currentUserInfo?.full_name || currentUserInfo?.first_name || `Пользователь #${currentUserId}`}
                                            </div>
                                            <div className="text-white text-sm">
                                                {partnersStructure.length} прямых партнеров
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        {navigationStack.length > 0 && (
                                            <button
                                                onClick={() => {
                                                    const previous = navigationStack[navigationStack.length - 1];
                                                    setPartnersStructure(previous.structure);
                                                    setCurrentUserId(previous.userId);
                                                    setCurrentUserInfo(previous.userInfo);
                                                    setNavigationStack(prev => prev.slice(0, -1));
                                                }}
                                                className="px-3 py-1 bg-blue-500/20 hover:bg-blue-500/30 text-white rounded-lg transition-colors text-sm flex items-center gap-1"
                                            >
                                                <ChevronLeft size={14} />
                                                Назад
                                            </button>
                                        )}
                                        <button
                                            onClick={() => {
                                                loadDashboardData();
                                                setCurrentUserId(userData?.id);
                                                setCurrentUserInfo(userData);
                                                setNavigationStack([]);
                                            }}
                                            className="px-3 py-1 bg-emerald-500/20 hover:bg-emerald-500/30 text-white rounded-lg transition-colors text-sm flex items-center gap-1"
                                        >
                                            <Home size={14} />
                                            Моя команда
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Статистика структуры */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                                <div className="text-center">
                                    <div className="text-2xl font-bold text-emerald-400">
                                        {partnersStructure.length}
                                    </div>
                                    <div className="text-sm text-white">Прямые партнеры</div>
                                </div>
                            </div>

                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                                <div className="text-center">
                                    <div className="text-2xl font-bold text-blue-400">
                                        {partnersStructure.filter(p => p.active).length}
                                    </div>
                                    <div className="text-sm text-white">Активные</div>
                                </div>
                            </div>

                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                                <div className="text-center">
                                    <div className="text-2xl font-bold text-purple-400">
                                        {partnersStructure.reduce((sum, p) => sum + (p.count_ref || 0), 0)}
                                    </div>
                                    <div className="text-sm text-white">Команды партнеров</div>
                                </div>
                            </div>

                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4">
                                <div className="text-center">
                                    <div className="text-2xl font-bold text-yellow-400">
                                        {partnersStructure.filter(p => p.level > 0).length}
                                    </div>
                                    <div className="text-sm text-white">В маркетинге</div>
                                </div>
                            </div>
                        </div>

                        {/* Рекурсивная структура партнеров */}
                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-4 md:p-6">
                            <div className="flex items-center justify-between mb-6">
                                <h3 className="text-xl font-semibold text-white">Структура партнеров</h3>
                                <button
                                    className="text-white hover:text-white transition-colors"
                                    title="Развернуть все"
                                    onClick={() => {
                                        if (window.Telegram?.WebApp) {
                                            window.Telegram.WebApp.showAlert('Нажмите на кнопку "👁" рядом с партнером, чтобы посмотреть его команду');
                                        } else {
                                            alert('Нажмите на кнопку "👁" рядом с партнером, чтобы посмотреть его команду');
                                        }
                                    }}
                                >
                                    <Eye size={20}/>
                                </button>
                            </div>

                            <div className="space-y-4">
                                {partnersStructure.map((partner) => (
                                    <PartnerNode key={partner.id} partner={partner} />
                                ))}
                            </div>

                            {partnersStructure.length === 0 && (
                                <div className="text-center py-8 text-white">
                                    <Users className="mx-auto mb-4 text-gray-500" size={48} />
                                    <p>У данного пользователя пока нет партнеров</p>
                                    {currentUserId === userData?.id && (
                                        <p className="text-sm mt-2">Поделитесь своей реферальной ссылкой!</p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );

            case 'structure':
                return renderStructureContent();

            case 'marketing':
                return renderMarketingContent();

            case 'tools':
                return (
                    <div className="space-y-6">
                        <div className="flex items-center justify-between">
                            <h2 className="text-2xl font-bold text-white">Наши Инструменты</h2>
                            <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20">
                                <Crown className="text-yellow-400" size={16} />
                                <span className="text-white text-sm font-semibold">Уровень {userData?.user_level || 0}</span>
                            </div>
                        </div>

                        <div className="bg-gradient-to-r from-orange-500/10 to-amber-500/10 border border-orange-500/20 rounded-2xl p-6 mb-8">
                            <div className="flex items-center gap-3 mb-4">
                                <Construction className="text-orange-400" size={24} />
                                <h3 className="text-xl font-semibold text-white">Все инструменты в разработке</h3>
                            </div>
                            <p className="text-white text-sm">
                                Команда активно работает над созданием уникальных инструментов для автоматизации
                                вашего бизнеса. Следите за обновлениями!
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {tools.map((tool) => (
                                <ToolCard key={tool.id} tool={tool} />
                            ))}
                        </div>

                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                            <h3 className="text-xl font-semibold text-white mb-4">Планируемые возможности</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="space-y-3">
                                    <h4 className="text-white font-medium">Персонализация</h4>
                                    <ul className="space-y-2 text-sm text-white">
                                        <li>• Индивидуальный дизайн для каждого инструмента</li>
                                        <li>• Настройка под ваш бренд и стиль</li>
                                        <li>• Персональные реферальные ссылки</li>
                                    </ul>
                                </div>

                                <div className="space-y-3">
                                    <h4 className="text-white font-medium">Аналитика</h4>
                                    <ul className="space-y-2 text-sm text-white">
                                        <li>• Отслеживание конверсий</li>
                                        <li>• Статистика использования</li>
                                        <li>• Детальная аналитика эффективности</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 'presentations':
                return (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-white mb-6">Презентации</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <h3 className="text-xl font-semibold text-white mb-4">Слайды PDF</h3>
                                <div className="mb-4">
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд1.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд1.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд2.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд2.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд3.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд3.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд4.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд4.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд5.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд5.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд6.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд6.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд7.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд7.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд8.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд8.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд9.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд9.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд10.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд10.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд11.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд11.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд12.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд12.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд13.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд13.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд14.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд14.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд15.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд15.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд16.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд16.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд17.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд17.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд18.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд18.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд19.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд19.JPG'} className={'w-100'}/>
                                    </div>
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/Слайд20.JPG';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/Слайд20.JPG'} className={'w-100'}/>
                                    </div>
                                </div>

                                <a href="https://frontends.b7774c.ru/presentation.pdf"
                                   target="_blank"
                                   className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white py-3 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2"
                                >
                                    <Download size={20}/>
                                    Скачать презентацию
                                </a>
                            </div>

                            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                                <h3 className="text-xl font-semibold text-white mb-4">Преимущества</h3>
                                <div className="mb-4">
                                    <div
                                        className="w-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-lg flex items-center justify-center border border-purple-500/20 cursor-pointer hover:scale-105 transition-transform"
                                        onClick={() => {
                                            // Создаем модальное окно для увеличенного просмотра
                                            const modal = document.createElement('div');
                                            modal.className = 'fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4';
                                            modal.onclick = () => modal.remove();

                                            const container = document.createElement('div');
                                            container.className = 'relative max-w-[95vw] max-h-[95vh] bg-white/5 rounded-lg overflow-hidden border border-white/20';
                                            container.onclick = (e) => e.stopPropagation();

                                            const img = document.createElement('img');
                                            img.src = '/preim.jpg';
                                            img.className = 'w-full h-auto object-contain';

                                            const closeBtn = document.createElement('button');
                                            closeBtn.innerHTML = '✕';
                                            closeBtn.className = 'absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold transition-colors';
                                            closeBtn.onclick = () => modal.remove();

                                            container.appendChild(img);
                                            container.appendChild(closeBtn);
                                            modal.appendChild(container);
                                            document.body.appendChild(modal);
                                        }}
                                    >
                                        <img src={'/preim.jpg'} className={'w-100'}/>
                                    </div>
                                </div>
                                <div className="text-center text-white text-sm">
                                    6 основных преимуществ системы CONCORD
                                    <br />
                                    <span className="text-xs text-white mt-1 block">Нажмите для увеличения</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                            <h3 className="text-xl font-semibold text-white mb-4">Материалы для партнеров</h3>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                {[
                                    { name: 'Инструкция для новичков', icon: FileText, color: 'emerald' },
                                    { name: 'Схемы вознаграждений', icon: TrendingUp, color: 'blue' },
                                    { name: 'FAQ по системе', icon: MessageCircle, color: 'purple' }
                                ].map((material) => (
                                    <div key={material.name} className={`bg-${material.color}-500/10 border border-${material.color}-500/20 rounded-xl p-4 hover:bg-${material.color}-500/20 transition-all duration-200 cursor-pointer`}>
                                        <material.icon className={`text-${material.color}-400 mb-2`} size={24} />
                                        <h4 className="text-white font-medium text-sm">{material.name}</h4>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );

            case 'documents':
                return (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-white mb-6">Документы</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {[
                                {
                                    name: 'Соглашение',
                                    description: 'Пользовательское соглашение',
                                    icon: File,
                                    color: 'emerald',
                                    link: 'https://telegra.ph/Soglashenie-04-30-3'
                                },
                                {
                                    name: 'Этика и правила',
                                    description: 'Правила поведения в сообществе',
                                    icon: FileText,
                                    color: 'blue',
                                    link: 'https://telegra.ph/EHtika-i-pravila-04-30'
                                }
                            ].map((doc) => (
                                <div
                                    key={doc.name}
                                    className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-200 cursor-pointer"
                                    onClick={() => openLink(doc.link)}
                                >
                                    <div className={`p-3 rounded-xl bg-${doc.color}-500/20 w-fit mb-4`}>
                                        <doc.icon className={`text-${doc.color}-400`} size={24} />
                                    </div>
                                    <h3 className="text-white font-semibold mb-2">{doc.name}</h3>
                                    <p className="text-white text-sm mb-4">{doc.description}</p>
                                    <div className="flex items-center gap-2 text-white text-sm hover:text-white transition-colors">
                                        <ExternalLink size={14} />
                                        Открыть документ
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
                            <h3 className="text-xl font-semibold text-white mb-4">Важная информация</h3>
                            <div className="space-y-4">
                                <div className="flex items-start gap-3">
                                    <CheckCircle className="text-emerald-400 mt-1" size={16} />
                                    <div>
                                        <div className="text-white font-medium">Прозрачность операций</div>
                                        <div className="text-white text-sm">Все транзакции проходят напрямую между участниками</div>
                                    </div>
                                </div>

                                <div className="flex items-start gap-3">
                                    <CheckCircle className="text-emerald-400 mt-1" size={16} />
                                    <div>
                                        <div className="text-white font-medium">Соблюдение правил</div>
                                        <div className="text-white text-sm">Обязательно ознакомьтесь с этикой и правилами</div>
                                    </div>
                                </div>

                                <div className="flex items-start gap-3">
                                    <CheckCircle className="text-emerald-400 mt-1" size={16} />
                                    <div>
                                        <div className="text-white font-medium">Поддержка</div>
                                        <div className="text-white text-sm">При вопросах обращайтесь к администрации</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 'groups':
                return (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-bold text-white mb-6">Группы и каналы</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {[
                                {
                                    name: 'Главная группа CONCORD',
                                    description: 'Основное сообщество участников',
                                    members: '1,234',
                                    color: 'emerald',
                                    link: 'https://t.me/concord_komanda'
                                },
                                {
                                    name: 'Поддержка',
                                    description: 'Техническая поддержка и помощь',
                                    members: '445',
                                    color: 'blue',
                                    link: 'https://t.me/poddershka_concord'
                                },
                                {
                                    name: 'Промоматериалы',
                                    description: 'Материалы для продвижения',
                                    members: '890',
                                    color: 'purple',
                                    link: 'https://t.me/concord_promo'
                                },
                                {
                                    name: 'Наши уровни',
                                    description: 'Обсуждение программм лояльности',
                                    members: '567',
                                    color: 'yellow',
                                    link: 'https://t.me/urovni_concord'
                                }
                            ].map((group) => (
                                <div key={group.name} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-200">
                                    <div className={`p-3 rounded-xl bg-${group.color}-500/20 w-fit mb-4`}>
                                        <MessageCircle className={`text-${group.color}-400`} size={24} />
                                    </div>
                                    <h3 className="text-white font-semibold mb-2">{group.name}</h3>
                                    <p className="text-white text-sm mb-4">{group.description}</p>
                                    <div className="flex items-center justify-between mb-4">
                                        <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
                                    </div>
                                    <button
                                        onClick={() => openLink(group.link)}
                                        className={`w-full bg-${group.color}-500/20 hover:bg-${group.color}-500/30 text-white py-2 px-4 rounded-lg transition-all duration-200 flex items-center justify-center gap-2`}
                                    >
                                        <ExternalLink size={16} />
                                        Присоединиться
                                    </button>
                                </div>
                            ))}
                        </div>

                        <div className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 rounded-2xl p-6">
                            <h3 className="text-xl font-semibold text-white mb-2">Правила участия в группах</h3>
                            <p className="text-white text-sm mb-4">
                                Для комфортного общения всех участников просим соблюдать правила:
                            </p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <div className="flex items-center gap-2 text-sm text-white">
                                        <CheckCircle className="text-emerald-400" size={14} />
                                        <span>Уважительное общение</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-white">
                                        <CheckCircle className="text-emerald-400" size={14} />
                                        <span>Без спама и рекламы</span>
                                    </div>
                                </div>
                                <div className="space-y-2">
                                    <div className="flex items-center gap-2 text-sm text-white">
                                        <CheckCircle className="text-emerald-400" size={14} />
                                        <span>Конструктивные обсуждения</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm text-white">
                                        <CheckCircle className="text-emerald-400" size={14} />
                                        <span>Соблюдение этики</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-900 via-green-800 to-green-900 relative overflow-hidden">
            {/* === НОВОГОДНЯЯ ТЕМА === */}
            <NewYearStyles />
            <Snowfall />

            {/* Animated background effects */}
            <div className="absolute inset-0">
                <div className="absolute top-20 left-20 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-20 right-20 w-96 h-96 bg-green-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
                <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl animate-pulse delay-2000"></div>
            </div>

            <div className="relative z-10">
                {/* === НОВОГОДНИЙ БАННЕР И ГИРЛЯНДА === */}
                <NewYearBanner />
                <ChristmasLights />

                {/* Header */}
                <header className="bg-white/5 backdrop-blur-md border-b border-white/10 ny-header-border">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex items-center justify-between h-16">
                            <div className="flex items-center gap-4">
                                {/* Menu button */}
                                <button
                                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                                    className="p-2 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition-colors"
                                >
                                    {isMenuOpen ? <X size={20}/> : <Menu size={20}/>}
                                </button>

                                {/* CONCORD Logo с новогодней шапкой */}
                                <div className="flex items-center gap-3">
                                    <div className="relative">
                                        <span className="absolute -top-4 left-1/2 -translate-x-1/2 text-2xl bounce-item">🎅</span>
                                        <img
                                            src="/logo.png"
                                            alt="CONCORD logo"
                                            className="w-[100px] h-auto"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-4">
                                <div
                                    className="flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20">
                                    <User className="text-white" size={16}/>
                                    <span className="text-white text-sm">{userData?.first_name || 'Пользователь'}</span>
                                </div>
                                <div className="relative">
                                    <button
                                        data-settings-button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const dropdown = document.getElementById('settings-dropdown');
                                            dropdown.classList.toggle('hidden');
                                        }}
                                        className="p-2 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 text-white hover:text-white transition-colors"
                                    >
                                        <Settings size={20}/>
                                    </button>

                                    {/* Dropdown меню */}
                                    <div
                                        id="settings-dropdown"
                                        className="hidden absolute right-0 mt-2 w-48 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg shadow-lg z-[9999]"
                                        style={{zIndex: 9999}}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="py-1">
                                            <button
                                                onClick={() => {
                                                    if (window.confirm('Вы уверены, что хотите выйти из аккаунта? Потребуется повторная авторизация.')) {
                                                        localStorage.removeItem('concord_token');
                                                        setToken(null);
                                                        setUserData(null);
                                                        setPartnersStructure([]);
                                                        setOperationsHistory([]);
                                                        setMarketingTreeData(null);
                                                        window.location.reload();
                                                    }
                                                    document.getElementById('settings-dropdown').classList.add('hidden');
                                                }}
                                                className="w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-2"
                                            >
                                                <RefreshCw size={14}/>
                                                Сменить аккаунт
                                            </button>
                                            <button
                                                onClick={() => {
                                                    if (window.Telegram?.WebApp) {
                                                        window.Telegram.WebApp.showAlert('Настройки будут доступны в следующих обновлениях');
                                                    } else {
                                                        alert('Настройки будут доступны в следующих обновлениях');
                                                    }
                                                    document.getElementById('settings-dropdown').classList.add('hidden');
                                                }}
                                                className="w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-2"
                                            >
                                                <Settings size={14}/>
                                                Настройки
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Sidebar Overlay */}
                {isMenuOpen && (
                    <div
                        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30"
                        onClick={() => setIsMenuOpen(false)}
                    />
                )}

                {/* Sidebar Navigation */}
                <div
                    className={`fixed left-0 top-16 h-[calc(100vh-4rem)] w-80 bg-green-800/80 backdrop-blur-md border-r border-green-600/30 z-40 transform transition-transform duration-300 overflow-y-auto ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}>
                    <div className="p-6">
                        {/* === НОВОГОДНИЕ УКРАШЕНИЯ === */}
                        <SidebarDecorations/>

                        <nav className="space-y-2">
                            {menuItems.map((item) => {
                                const Icon = item.icon;
                                const isInDevelopment = ['tools'].includes(item.id);
                                return (
                                    <button
                                        key={item.id}
                                        onClick={() => {
                                            setActiveTab(item.id);
                                            setIsMenuOpen(false);
                                        }}
                                        className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left transition-all duration-200 ${activeTab === item.id
                                            ? 'bg-gradient-to-r from-emerald-600/40 to-green-700/40 border border-emerald-500/50 text-white shadow-lg shadow-emerald-500/20'
                                            : `bg-white/10 backdrop-blur-md border border-white/20 text-green-100 hover:bg-white/20 hover:text-white ${isInDevelopment ? 'opacity-80' : ''}`
                                        }`}
                                    >
                                        <Icon size={20}/>
                                        <span className="font-medium flex-1">{item.label}</span>
                                        {isInDevelopment && (
                                            <Construction className="text-orange-400" size={16}/>
                                        )}
                                    </button>
                                );
                            })}
                        </nav>

                        {/* User info in sidebar */}
                        <div className="mt-8 p-4 bg-white/10 rounded-xl border border-white/20">
                            <div className="flex items-center gap-3 mb-3">
                                <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center">
                                    <User className="text-white" size={16} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="text-white font-medium text-sm truncate">
                                        {userData?.full_name || `${userData?.first_name} ${userData?.last_name}` || 'Пользователь'}
                                    </div>
                                    <div className="text-green-300 text-xs">@{userData?.login || 'username'}</div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2 text-center">
                                <div className="bg-white/10 rounded-lg p-2">
                                    <div className="text-emerald-400 font-bold text-sm">${userData?.balance?.toFixed(0) || '0'}</div>
                                    <div className="text-white text-xs">Доход</div>
                                </div>
                                <div className="bg-white/10 rounded-lg p-2">
                                    <div className="text-blue-400 font-bold text-sm">
                                        {partnersStructure.length}
                                    </div>
                                    <div className="text-white text-xs">Команда</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 lg:p-8 min-h-[600px]">
                        {renderContent()}
                    </div>
                </div>
            </div>

            {/* Стили для маркетингового дерева */}
            <style jsx>{`
                .activation-message {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 40px 30px;
                    background: rgba(0, 92, 43, 0.8);
                    border-radius: 15px;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
                    text-align: center;
                    border: 2px solid #10b981;
                    position: relative;
                    width: 90%;
                    max-width: 400px;
                    overflow: hidden;
                    margin: 0 auto;
                }

                .message-icon {
                    font-size: 60px;
                    margin-bottom: 20px;
                    color: #10b981;
                }

                .message-title {
                    color: #10b981;
                    font-size: 1.8rem;
                    margin-bottom: 20px;
                    font-weight: bold;
                    letter-spacing: 1px;
                    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
                }

                .message-content {
                    font-size: 1.2rem;
                    line-height: 1.5;
                    margin-bottom: 25px;
                    color: #d1fae5;
                    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
                }

                .retry-button {
                    background: #10b981;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 8px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: background-color 0.2s;
                }

                .retry-button:hover {
                    background: #059669;
                }

                .shimmer {
                    background: linear-gradient(
                        90deg,
                        #d1fae5 0%,
                        #10b981 50%,
                        #d1fae5 100%
                    );
                    background-size: 200% auto;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    animation: shimmer 2s linear infinite;
                    display: inline-block;
                }

                @keyframes shimmer {
                    0% { background-position: 0% center; }
                    100% { background-position: 200% center; }
                }

                .search-container {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 30px;
                }

                .search-wrapper {
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    background: rgba(255, 255, 255, 0.05);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 12px;
                    padding: 8px;
                }

                .search-input {
                    background: transparent;
                    border: none;
                    color: white;
                    padding: 8px 12px;
                    font-size: 14px;
                    outline: none;
                    min-width: 200px;
                }

                .search-input::placeholder {
                    color: rgba(255, 255, 255, 0.5);
                }

                .search-button {
                    background: #10b981;
                    border: none;
                    border-radius: 8px;
                    color: white;
                    padding: 8px 12px;
                    cursor: pointer;
                    transition: background-color 0.2s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .search-button:hover {
                    background: #059669;
                }

                .marketing-tree {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    overflow-x: auto;
                    padding: 20px;
                    background: rgba(255, 255, 255, 0.02);
                    border-radius: 20px;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                }

                .level {
                    display: flex;
                    justify-content: center;
                    gap: 40px;
                    flex-wrap: nowrap;
                }

                .level-1 {
                    margin-bottom: 10px;
                }

                .level-2 {
                    margin-bottom: 10px;
                }

                .level-3-container {
                    width: 100%;
                    overflow-x: auto;
                    padding: 10px 0;
                }

                .level-3 {
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                    min-width: max-content;
                    flex-wrap: nowrap;
                }

                .marketing-node {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 15px;
                    background: rgba(255, 255, 255, 0.05);
                    backdrop-filter: blur(10px);
                    border: 2px solid rgba(16, 185, 129, 0.3);
                    border-radius: 15px;
                    width: 120px;
                    height: 160px;
                    transition: all 0.3s ease;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .marketing-node:hover {
                    border-color: rgba(16, 185, 129, 0.6);
                    box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2);
                }

                .marketing-node.empty-node {
                    border-color: rgba(107, 114, 128, 0.3);
                    opacity: 0.6;
                }

                .avatar {
                    position: relative;
                    margin-bottom: 8px;
                }

                .avatar-placeholder {
                    width: 70px;
                    height: 35px;
                    border-radius: 8px;
                    background: linear-gradient(135deg, #10b981, #059669);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-weight: bold;
                    font-size: 16px;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                    margin-bottom: 8px;
                }

                .empty-node .avatar-placeholder {
                    background: linear-gradient(135deg, #6b7280, #4b5563);
                }

                .avatar-badge {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: #f59e0b;
                    color: white;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    font-weight: bold;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
                }

                .film-effect {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(
                        45deg,
                        transparent 30%,
                        rgba(255, 255, 255, 0.1) 50%,
                        transparent 70%
                    );
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    pointer-events: none;
                }

                .marketing-node:hover .film-effect {
                    opacity: 1;
                }

                .reservation-label {
                    color: #f59e0b;
                    font-size: 11px;
                    font-weight: bold;
                    margin-bottom: 4px;
                    background: rgba(245, 158, 11, 0.2);
                    padding: 2px 6px;
                    border-radius: 4px;
                    border: 1px solid rgba(245, 158, 11, 0.3);
                }

                .telegram-link {
                    color: #ffffff;
                    background: rgba(245, 158, 11, 0.9);
                    font-size: 16px;
                    font-weight: bold;
                    text-decoration: none;
                    margin-top: 6px;
                    padding: 6px 10px;
                    border-radius: 8px;
                    border: 2px solid #f59e0b;
                    transition: all 0.2s;
                    max-width: 100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
                }

                .telegram-link:hover {
                    background: #f59e0b;
                    color: #ffffff;
                    transform: scale(1.05);
                }

                .connector {
                    width: 2px;
                    height: 15px;
                    background: rgba(16, 185, 129, 0.4);
                }

                .horizontal-connector {
                    width: 200px;
                    height: 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .h-line {
                    width: 100%;
                    height: 2px;
                    background: rgba(16, 185, 129, 0.4);
                }

                .level-1-vertical-connectors {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 10px;
                }

                .level-1-v-connectors-group {
                    display: flex;
                    gap: 120px;
                }

                .level-1-v-connector {
                    width: 2px;
                    height: 15px;
                    background: rgba(16, 185, 129, 0.4);
                }

                .v-connectors {
                    display: flex;
                    justify-content: center;
                    gap: 60px;
                    margin-bottom: 10px;
                    flex-wrap: nowrap;
                }

                .v-connector {
                    width: 2px;
                    height: 15px;
                    background: rgba(16, 185, 129, 0.4);
                }

                @media (max-width: 768px) {
                    .marketing-tree {
                        padding: 10px;
                        gap: 5px;
                    }

                    .level {
                        gap: 20px;
                    }

                    .level-3 {
                        gap: 15px;
                    }

                    .marketing-node {
                        width: 75px;
                        height: 95px;
                        padding: 8px;
                    }

                    .avatar-placeholder {
                        width: 50px;
                        height: 24px;
                        font-size: 11px;
                        border-radius: 5px;
                    }

                    .search-input {
                        min-width: 150px;
                    }

                    .v-connectors {
                        gap: 35px;
                    }

                    .level-1-v-connectors-group {
                        gap: 70px;
                    }

                    .telegram-link {
                        font-size: 10px;
                        max-width: 65px;
                        padding: 2px 4px;
                    }

                    .reservation-label {
                        font-size: 8px;
                        padding: 1px 3px;
                    }

                    .avatar-badge {
                        width: 18px;
                        height: 18px;
                        font-size: 11px;
                        border: 2px solid rgba(255, 255, 255, 0.3);
                        top: -5px;
                        right: -5px;
                    }

                    .connector,
                    .level-1-v-connector,
                    .v-connector {
                        height: 8px;
                    }

                    .level-1,
                    .level-2,
                    .level-1-vertical-connectors,
                    .v-connectors {
                        margin-bottom: 4px;
                    }

                    .level-3 {
                        gap: 12px;
                        padding: 0 5px;
                    }
                }
            `}</style>
        </div>
    );
};

export default ConcordWebApp;
